
/*
=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
Table of Contents
=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=

    - Theme View
        - Header View
            - Currency View
            - Navigation View
                - Mobile navigation View
                - Mega navigation View
        - Template View
            - QuickShop View
            - Index View
                - Slideshow View
                - Instagram View
            - Collection View
            - List Collections View
            - Product View
                - Image zoom View
            - Cart View
            - Page View
            - The404View
            - Blog View
            - Password Protect Page View
            - GiftCard View

=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
var AccountView, BODY, CartView, CollectionListView, CollectionView, GiftCardView, HeaderView, IndexView, InstagramView, ListCollectionsView, MegaNavigationView, MobileNavigationView, NavigationView, PasswordView, ProductView, QuickShopView, RTEView, SharingWidgetView, SlideshowView, TOUCH, ThemeView, TwitterView, VideoView, WINDOW,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

window.ThemeEditor = (function(superClass) {
  extend(ThemeEditor, superClass);

  function ThemeEditor() {
    return ThemeEditor.__super__.constructor.apply(this, arguments);
  }

  ThemeEditor.prototype.initialize = function() {
    this.instanceHandlers = {};
    this.instances = {};
    return $(document).on('shopify:section:load', (function(_this) {
      return function(event) {
        return _this._onSectionLoad(event);
      };
    })(this)).on('shopify:section:unload', (function(_this) {
      return function(event) {
        return _this._onSectionUnload(event);
      };
    })(this)).on('shopify:section:select', (function(_this) {
      return function(event) {
        return _this._onSectionSelect(event);
      };
    })(this)).on('shopify:section:deselect', (function(_this) {
      return function(event) {
        return _this._onSectionDeselect(event);
      };
    })(this)).on('shopify:block:select', (function(_this) {
      return function(event) {
        return _this._onBlockSelect(event);
      };
    })(this)).on('shopify:block:deselect', (function(_this) {
      return function(event) {
        return _this._onBlockDeselect(event);
      };
    })(this));
  };

  ThemeEditor.prototype._findInstance = function(event) {
    var $container, instance;
    instance = this.instances[event.originalEvent.detail.sectionId];
    if (instance != null) {
      return instance;
    } else {
      $container = $('[data-section-id]', event.target);
      return this._createInstance($container);
    }
  };

  ThemeEditor.prototype._createInstance = function($container, instanceHandler) {
    var data, el, instance, sectionId, sectionType;
    el = $container.parent().get(0);
    data = this._loadData(el);
    sectionType = $container.attr('data-section-type');
    sectionId = $container.attr('data-section-id');
    if (sectionType == null) {
      return;
    }
    instanceHandler = instanceHandler || this.instanceHandlers[sectionType];
    instance = {
      el: el,
      data: data,
      instanceHandler: instanceHandler,
      el: el,
      data: data,
      $container: $container,
      sectionId: sectionId
    };
    this.instances[sectionId] = instance;
    return instance;
  };

  ThemeEditor.prototype._loadData = function(el) {
    var data, dataEl, error;
    dataEl = el.querySelector('[data-section-data]');
    if (!dataEl) {
      return {};
    }
    data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
    try {
      return JSON.parse(data);
    } catch (error1) {
      error = error1;
      console.warn("Sections: invalid section data found. " + error.message);
      return {};
    }
  };


  /*
      Action: A section has been added or re-rendered.
      Expected: Re-execute any JavaScript needed for the section to work and
          display properly (as if the page had just been loaded).
   */

  ThemeEditor.prototype._onSectionLoad = function(event) {
    var $container, ref, ref1;
    $container = $('[data-section-id]', event.target);
    if (!$container.length) {
      return;
    }
    return (ref = this._createInstance($container)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionLoad === "function" ? ref1.onSectionLoad(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: A section has been deleted or is being re-rendered.
      Expected: Clean up any event listeners, variables, etc., so that
          nothing breaks when the page is interacted with and no memory leaks occur.
   */

  ThemeEditor.prototype._onSectionUnload = function(event) {
    var instance, ref;
    instance = this._findInstance(event);
    if (instance != null) {
      if ((ref = instance.instanceHandler) != null) {
        if (typeof ref.onSectionUnload === "function") {
          ref.onSectionUnload(event);
        }
      }
    }
    if (instance) {
      return delete this.instances[instance.sectionId];
    }
  };


  /*
      Action: User has selected the section in the sidebar.
      Expected: Make sure the section is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Could be used to pause a slideshow
   */

  ThemeEditor.prototype._onSectionSelect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionSelect === "function" ? ref1.onSectionSelect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has deselected the section in the sidebar.
      Expected: (None)
      Example: Could be used to restart slideshows that are no longer being interacted with.
   */

  ThemeEditor.prototype._onSectionDeselect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionDeselect === "function" ? ref1.onSectionDeselect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has selected the block in the sidebar.
      Expected: Make sure the block is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Can be used to to trigger a slideshow to bring a slide/block into view
   */

  ThemeEditor.prototype._onBlockSelect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockSelect === "function" ? ref1.onBlockSelect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has deselected the block in the sidebar.
      Expected: (None)
      Example: Resume a slideshow
   */

  ThemeEditor.prototype._onBlockDeselect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockDeselect === "function" ? ref1.onBlockDeselect(event) : void 0 : void 0 : void 0;
  };


  /*
      Auto initialisation of a section for the store front
   */

  ThemeEditor.prototype._sectionInit = function(instance) {
    var ref;
    return instance != null ? (ref = instance.instanceHandler) != null ? typeof ref.init === "function" ? ref.init(instance) : void 0 : void 0 : void 0;
  };


  /*
      Registration of a section
          - Takes a string parameter as the first argument which
            matches to `[data-section-type]`
       * Example
          @sections = new Sections()
          @sections.register('some-section-type', @someSectionClass)
   */

  ThemeEditor.prototype.register = function(type, instanceHandler) {

    /*
        Storage of a instanceHandler based on the sectionType allows _onSectionLoad
           to connect a new section to it's registered instanceHandler
     */
    this.instanceHandlers[type] = instanceHandler;
    return $("[data-section-type=" + type + "]").each((function(_this) {
      return function(index, container) {
        var $container;
        $container = $(container);
        return _this._sectionInit(_this._createInstance($container, instanceHandler));
      };
    })(this));
  };


  /*
      Public method to retrieve information on an instance based on the
      bubbled `event`
   */

  ThemeEditor.prototype.getInstance = function(event) {
    return this._findInstance(event);
  };

  return ThemeEditor;

})(Backbone.View);

window.ThemeUtils = {
  extend: function() {
    var dest, j, k, len, obj, objs, v;
    dest = arguments[0], objs = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    for (j = 0, len = objs.length; j < len; j++) {
      obj = objs[j];
      for (k in obj) {
        v = obj[k];
        dest[k] = v;
      }
    }
    return dest;
  },
  windowWidth: function() {
    return window.innerWidth || this.window.width();
  },
  debounce: function(func, wait, immediate) {
    var timeout;
    timeout = null;
    return function() {
      var args, callNow, context, later;
      context = this;
      args = arguments;
      later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  },
  inViewport: function(el) {
    var bounds, rect;
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    rect = el.getBoundingClientRect();
    bounds = {
      top: rect.top >= 0,
      bottom: rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    };
    return bounds.top && bounds.bottom;
  },
  unique: function(array) {
    var j, key, output, ref, results, value;
    output = {};
    for (key = j = 0, ref = array.length; 0 <= ref ? j < ref : j > ref; key = 0 <= ref ? ++j : --j) {
      output[array[key]] = array[key];
    }
    results = [];
    for (key in output) {
      value = output[key];
      results.push(value);
    }
    return results;
  }
};

window.LinkedOptions = (function() {
  function LinkedOptions(options) {
    this.options = options;
    this._init();
  }

  LinkedOptions.prototype._init = function() {
    return this._mapVariants(this.options.productJSON);
  };

  LinkedOptions.prototype._getCurrent = function(optionIndex) {
    var key, option1, option2, selector;
    if (this.options.type === 'select') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector.eq(0);
          break;
        case 1:
          key = this.options.$selector.eq(0).val();
          selector = this.options.$selector.eq(1);
          break;
        case 2:
          key = (this.options.$selector.eq(0).val()) + " / " + (this.options.$selector.eq(1).val());
          selector = this.options.$selector.eq(2);
      }
    }
    if (this.options.type === 'radio') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector.filter('[data-option-index=0]').filter(':checked');
          break;
        case 1:
          key = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
          selector = this.options.$selector.filter('[data-option-index=1]').filter(':checked');
          break;
        case 2:
          option1 = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
          option2 = this.options.$selector.filter('[data-option-index=1]').filter(':checked').val();
          key = option1 + " / " + option2;
          selector = this.options.$selector.filter('[data-option-index=2]').filter(':checked');
      }
    }
    return {
      key: key,
      selector: selector
    };
  };

  LinkedOptions.prototype._updateOptions = function(optionIndex, optionsMap) {
    var $nextOption, $option, $selector, $selectorOptions, availableOptions, initialValue, j, key, l, len, len1, nextSelector, option, ref, selector, updateSelected;
    nextSelector = optionIndex + 1;
    updateSelected = false;
    ref = this._getCurrent(optionIndex), key = ref.key, selector = ref.selector;
    availableOptions = optionsMap[key] || [];
    if (this.options.type === 'select') {
      $selector = this.options.$productForm.find(selector);
      initialValue = $selector.val();
      $selectorOptions = $selector.find('option');
      for (j = 0, len = $selectorOptions.length; j < len; j++) {
        option = $selectorOptions[j];
        $option = $(option);
        if (availableOptions.indexOf(option.value) === -1) {
          if (option.selected) {
            updateSelected = true;
          }
          $option.prop('disabled', true).prop('selected', false);
        } else {
          $option.prop('disabled', false);
        }
      }
      if (availableOptions.indexOf(initialValue) !== -1) {
        $selector.val(initialValue);
      }
      if (updateSelected) {
        $selectorOptions.filter(':not(:disabled)').eq(0).prop('selected', true);
      }
    }
    if (this.options.type === 'radio') {
      $selector = this.options.$selector.filter("[data-option-index=" + optionIndex + "]");
      for (l = 0, len1 = $selector.length; l < len1; l++) {
        option = $selector[l];
        $option = $(option);
        if (availableOptions.indexOf(option.value) === -1) {
          if (option.checked) {
            updateSelected = true;
          }
          $option.prop('disabled', true).prop('checked', false);
        } else {
          $option.prop('disabled', false);
        }
      }
      if (updateSelected) {
        $selector.filter(':not(:disabled)').eq(0).attr('checked', true).trigger('click');
      }
    }
    $selector.trigger('change');
    $nextOption = this.options.$selector.filter("[data-option-index=" + nextSelector + "]");
    if ($nextOption.length !== 0) {
      return this._updateOptions(nextSelector, optionsMap);
    }
  };

  LinkedOptions.prototype._mapVariants = function(product) {
    var j, key, len, optionsMap, ref, variant;
    optionsMap = [];
    optionsMap['root'] = [];
    ref = product.variants;
    for (j = 0, len = ref.length; j < len; j++) {
      variant = ref[j];
      if (variant.available) {
        optionsMap['root'].push(variant.option1);
        optionsMap['root'] = window.ThemeUtils.unique(optionsMap['root']);
        if (product.options.length > 1) {
          key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
        }
        if (product.options.length > 2) {
          key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
        }
      }
    }
    this._updateOptions(0, optionsMap);
    return this.options.$selector.on('change', (function(_this) {
      return function(event) {
        var index, nextSelector;
        index = parseInt($(event.currentTarget).attr('data-option-index'), 10);
        nextSelector = index + 1;
        return _this._updateOptions(nextSelector, optionsMap);
      };
    })(this));
  };

  return LinkedOptions;

})();

window.VariantHelper = (function() {
  function VariantHelper(options) {
    var defaultOptions, isShopify;
    defaultOptions = {
      $addToCartButton: null,
      $priceFields: null,
      $productForm: null,
      $productThumbnails: null,
      $selector: null,
      type: 'select',
      productJSON: null,
      productSettings: null
    };
    this.options = window.ThemeUtils.extend(defaultOptions, options);
    this.$body = $(document.body);
    this.linkedOptions = null;
    this.enableHistory = false;
    this.$masterSelect = this.options.$productForm.find("#product-select-" + this.options.formID);
    this.$smartPaymentButtons = this.options.$productForm.find(".shopify-payment-button");
    isShopify = window.Shopify && window.Shopify.preview_host;
    if (window.history && window.history.replaceState && this.options.productSettings.enableHistory && !isShopify) {
      this.enableHistory = true;
    }
    this._init();
    this._bindEvents();
  }

  VariantHelper.prototype._init = function() {
    var j, len, ref, select;
    if (this.options.type === 'select') {
      ref = this.options.$selector;
      for (j = 0, len = ref.length; j < len; j++) {
        select = ref[j];
        this._setSelectLabel(null, $(select));
      }
    }
    if (this.options.productSettings.linkedOptions) {
      this.linkedOptions = new LinkedOptions(this.options);
    }
    return this._updateCurrency();
  };

  VariantHelper.prototype._bindEvents = function() {
    return this.options.$selector.on('change.variant-helper', (function(_this) {
      return function(event) {
        return _this._variantChange(event);
      };
    })(this));
  };

  VariantHelper.prototype.unload = function() {
    return this.options.$selector.off('.variant-helper');
  };

  VariantHelper.prototype._setSelectLabel = function(event, $target) {
    var selectedOption;
    if (event == null) {
      event = null;
    }
    if ($target == null) {
      $target = false;
    }
    if (!$target) {
      $target = $(event.currentTarget);
    }
    selectedOption = $target.find('option:selected').val();
    return $target.prev('[data-select-text]').find('[data-selected-option]').text(selectedOption);
  };

  VariantHelper.prototype._getCurrentOptions = function() {
    var $inputs, productOptions;
    productOptions = [];
    $inputs = this.options.$selector;
    if (this.options.type === 'radio') {
      $inputs = $inputs.filter(':checked');
    }
    $inputs.each(function(index, element) {
      return productOptions.push($(element).val());
    });
    return productOptions;
  };

  VariantHelper.prototype._getVariantFromOptions = function(productOptions) {
    var foundVariant, isMatch, j, len, ref, variant;
    if (this.options.productJSON.variants == null) {
      return;
    }
    foundVariant = null;
    ref = this.options.productJSON.variants;
    for (j = 0, len = ref.length; j < len; j++) {
      variant = ref[j];
      isMatch = productOptions.every(function(value, index) {
        return variant.options[index] === value;
      });
      if (isMatch) {
        foundVariant = variant;
      }
    }
    return foundVariant;
  };

  VariantHelper.prototype._updateMasterSelect = function(variant) {
    var $newOption;
    if (variant == null) {
      return;
    }
    $newOption = this.$masterSelect.find("[data-variant-id=" + variant.id + "]");
    if ($newOption.length) {
      this.$masterSelect.find("option:selected").prop('selected', false);
      $newOption.prop('selected', true);
    }
    return this.$masterSelect.trigger('change');
  };

  VariantHelper.prototype._updatePrice = function(variant) {
    var $addToCartButton, $moneyEl, $priceFields, attribute, j, l, len, len1, priceField, productSettings, ref;
    $addToCartButton = this.options.$addToCartButton;
    $priceFields = this.options.$priceFields;
    productSettings = this.options.productSettings;
    if (variant) {
      for (j = 0, len = $priceFields.length; j < len; j++) {
        priceField = $priceFields[j];
        $moneyEl = $(priceField).children('.money');
        ref = $moneyEl[0].attributes;
        for (l = 0, len1 = ref.length; l < len1; l++) {
          attribute = ref[l];
          if (attribute.name.indexOf("data-") > -1) {
            $moneyEl.attr(attribute.name, "");
          }
        }
      }
      if (variant.available) {
        $addToCartButton.val(productSettings.addToCartText).removeClass('disabled').removeAttr('disabled');
      } else {
        $addToCartButton.val(productSettings.soldOutText).addClass('disabled').attr('disabled', 'disabled');
      }
      if (variant.compare_at_price > variant.price) {
        $priceFields.find('.money:not(.original)').html(Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency", Theme.currency);
        $priceFields.find('.money.original').html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).removeClass('hidden').attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      } else {
        $priceFields.find('.money:not(.original)').html(Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency", Theme.currency);
        $priceFields.find('.money.original').addClass('hidden').attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      }
    } else {
      $addToCartButton.val(productSettings.unavailableText).addClass('disabled').attr('disabled', 'disabled');
    }
    return this._updateCurrency();
  };

  VariantHelper.prototype._updateImages = function(variant) {
    var imageId, ref;
    imageId = variant != null ? (ref = variant.featured_image) != null ? ref.id : void 0 : void 0;
    if (this.options.$productMainImage != null) {
      this.options.$productMainImage.trigger('resetZoom');
    }
    if (imageId == null) {
      return;
    }
    return this.options.$productThumbnails.filter("[data-image-id='" + imageId + "']").parent().trigger('click');
  };

  VariantHelper.prototype._updateHistory = function(variant) {
    var newUrl, variantUrl;
    if (!(this.enableHistory && (variant != null))) {
      return;
    }
    newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant.id];
    variantUrl = newUrl.join('');
    return window.history.replaceState({
      path: variantUrl
    }, '', variantUrl);
  };

  VariantHelper.prototype._variantChange = function(event) {
    var productOptions, variant;
    if (this.options.type === 'select') {
      this._setSelectLabel(event);
    }
    productOptions = this._getCurrentOptions();
    variant = this._getVariantFromOptions(productOptions);
    this._updateMasterSelect(variant);
    this._updatePrice(variant);
    this._updateImages(variant);
    this._updateHistory(variant);
    return this._updateSmartPaymentButtons(variant);
  };

  VariantHelper.prototype._updateSmartPaymentButtons = function(variant) {
    if (variant.available) {
      return this.$smartPaymentButtons.slideDown();
    } else {
      return this.$smartPaymentButtons.slideUp();
    }
  };

  VariantHelper.prototype._updateCurrency = function() {
    if (Theme.currencySwitcher) {
      return $(document.body).trigger("switch-currency");
    }
  };

  return VariantHelper;

})();


/*********************************************************************
*  #### Twitter Post Fetcher v17.0.3 ####
*  Coded by Jason Mayes 2015. A present to all the developers out there.
*  www.jasonmayes.com
*  Please keep this disclaimer with my code if you use it. Thanks. :-)
*  Got feedback or questions, ask here:
*  http://www.jasonmayes.com/projects/twitterApi/
*  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
*  Updates will be posted to this site.
*********************************************************************/
(function(root,factory){if(typeof define==='function'&&define.amd){define([],factory);}else if(typeof exports==='object'){module.exports=factory();}else{factory();}}(this,function(){var domNode='';var maxTweets=20;var parseLinks=true;var queue=[];var inProgress=false;var printTime=true;var printUser=true;var formatterFunction=null;var supportsClassName=true;var showRts=true;var customCallbackFunction=null;var showInteractionLinks=true;var showImages=false;var useEmoji=false;var targetBlank=true;var lang='en';var permalinks=true;var dataOnly=false;var script=null;var scriptAdded=false;function handleTweets(tweets){if(customCallbackFunction===null){var x=tweets.length;var n=0;var element=document.getElementById(domNode);var html='<ul>';while(n<x){html+='<li>'+tweets[n]+'</li>';n++;}
html+='</ul>';element.innerHTML=html;}else{customCallbackFunction(tweets);}}
function strip(data){return data.replace(/<b[^>]*>(.*?)<\/b>/gi,function(a,s){return s;}).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,'');}
function targetLinksToNewWindow(el){var links=el.getElementsByTagName('a');for(var i=links.length-1;i>=0;i--){links[i].setAttribute('target','_blank');}}
function getElementsByClassName(node,classname){var a=[];var regex=new RegExp('(^| )'+classname+'( |$)');var elems=node.getElementsByTagName('*');for(var i=0,j=elems.length;i<j;i++){if(regex.test(elems[i].className)){a.push(elems[i]);}}
return a;}
function extractImageUrl(image_data){if(image_data!==undefined&&image_data.innerHTML.indexOf('data-image')>=0){var data_src=image_data.innerHTML.match(/data-image=\"([A-z0-9]+:\/\/[A-z0-9]+\.[A-z0-9]+\.[A-z0-9]+\/[A-z0-9]+\/[A-z0-9\-]+)/i)[1];return decodeURIComponent(data_src)+'.jpg';}}
var twitterFetcher={fetch:function(config){if(config.maxTweets===undefined){config.maxTweets=20;}
if(config.enableLinks===undefined){config.enableLinks=true;}
if(config.showUser===undefined){config.showUser=true;}
if(config.showTime===undefined){config.showTime=true;}
if(config.dateFunction===undefined){config.dateFunction='default';}
if(config.showRetweet===undefined){config.showRetweet=true;}
if(config.customCallback===undefined){config.customCallback=null;}
if(config.showInteraction===undefined){config.showInteraction=true;}
if(config.showImages===undefined){config.showImages=false;}
if(config.useEmoji===undefined){config.useEmoji=false;}
if(config.linksInNewWindow===undefined){config.linksInNewWindow=true;}
if(config.showPermalinks===undefined){config.showPermalinks=true;}
if(config.dataOnly===undefined){config.dataOnly=false;}
if(inProgress){queue.push(config);}else{inProgress=true;domNode=config.domId;maxTweets=config.maxTweets;parseLinks=config.enableLinks;printUser=config.showUser;printTime=config.showTime;showRts=config.showRetweet;formatterFunction=config.dateFunction;customCallbackFunction=config.customCallback;showInteractionLinks=config.showInteraction;showImages=config.showImages;useEmoji=config.useEmoji;targetBlank=config.linksInNewWindow;permalinks=config.showPermalinks;dataOnly=config.dataOnly;var head=document.getElementsByTagName('head')[0];if(script!==null){head.removeChild(script);}
script=document.createElement('script');script.type='text/javascript';if(config.list!==undefined){script.src='https://syndication.twitter.com/timeline/list?'+'callback=__twttrf.callback&dnt=false&list_slug='+
config.list.listSlug+'&screen_name='+config.list.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else if(config.profile!==undefined){script.src='https://syndication.twitter.com/timeline/profile?'+'callback=__twttrf.callback&dnt=false'+'&screen_name='+config.profile.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else if(config.likes!==undefined){script.src='https://syndication.twitter.com/timeline/likes?'+'callback=__twttrf.callback&dnt=false'+'&screen_name='+config.likes.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else{script.src='https://cdn.syndication.twimg.com/widgets/timelines/'+
config.id+'?&lang='+(config.lang||lang)+'&callback=__twttrf.callback&'+'suppress_response_codes=true&rnd='+Math.random();}
head.appendChild(script);}},callback:function(data){if(data===undefined||data.body===undefined){inProgress=false;if(queue.length>0){twitterFetcher.fetch(queue[0]);queue.splice(0,1);}
return;}
if(!useEmoji){data.body=data.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,'');}
if(!showImages){data.body=data.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,'');}
if(!printUser){data.body=data.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g,'');}
var div=document.createElement('div');div.innerHTML=data.body;if(typeof(div.getElementsByClassName)==='undefined'){supportsClassName=false;}
function swapDataSrc(element){var avatarImg=element.getElementsByTagName('img')[0];if(avatarImg && avatarImg.length){avatarImg.src=avatarImg.getAttribute('data-src-2x');}return element;}
var tweets=[];var authors=[];var times=[];var images=[];var rts=[];var tids=[];var permalinksURL=[];var x=0;if(supportsClassName){var tmp=div.getElementsByClassName('timeline-Tweet');while(x<tmp.length){if(tmp[x].getElementsByClassName('timeline-Tweet-retweetCredit').length>0){rts.push(true);}else{rts.push(false);}
if(!rts[x]||rts[x]&&showRts){tweets.push(tmp[x].getElementsByClassName('timeline-Tweet-text')[0]);tids.push(tmp[x].getAttribute('data-tweet-id'));if(printUser){authors.push(swapDataSrc(tmp[x].getElementsByClassName('timeline-Tweet-author')[0]));}
times.push(tmp[x].getElementsByClassName('dt-updated')[0]);permalinksURL.push(tmp[x].getElementsByClassName('timeline-Tweet-timestamp')[0]);if(tmp[x].getElementsByClassName('timeline-Tweet-media')[0]!==undefined){images.push(tmp[x].getElementsByClassName('timeline-Tweet-media')[0]);}else{images.push(undefined);}}
x++;}}else{var tmp=getElementsByClassName(div,'timeline-Tweet');while(x<tmp.length){if(getElementsByClassName(tmp[x],'timeline-Tweet-retweetCredit').length>0){rts.push(true);}else{rts.push(false);}
if(!rts[x]||rts[x]&&showRts){tweets.push(getElementsByClassName(tmp[x],'timeline-Tweet-text')[0]);tids.push(tmp[x].getAttribute('data-tweet-id'));if(printUser){authors.push(swapDataSrc(getElementsByClassName(tmp[x],'timeline-Tweet-author')[0]));}
times.push(getElementsByClassName(tmp[x],'dt-updated')[0]);permalinksURL.push(getElementsByClassName(tmp[x],'timeline-Tweet-timestamp')[0]);if(getElementsByClassName(tmp[x],'timeline-Tweet-media')[0]!==undefined){images.push(getElementsByClassName(tmp[x],'timeline-Tweet-media')[0]);}else{images.push(undefined);}}
x++;}}
if(tweets.length>maxTweets){tweets.splice(maxTweets,(tweets.length-maxTweets));authors.splice(maxTweets,(authors.length-maxTweets));times.splice(maxTweets,(times.length-maxTweets));rts.splice(maxTweets,(rts.length-maxTweets));images.splice(maxTweets,(images.length-maxTweets));permalinksURL.splice(maxTweets,(permalinksURL.length-maxTweets));}
var arrayTweets=[];var x=tweets.length;var n=0;if(dataOnly){while(n<x){arrayTweets.push({tweet:tweets[n].innerHTML,author:authors[n]?authors[n].innerHTML:'Unknown Author',author_data:{profile_url:authors[n]?authors[n].querySelector('[data-scribe="element:user_link"]').href:null,profile_image:authors[n]?authors[n].querySelector('[data-scribe="element:avatar"]').getAttribute('data-src-1x'):null,profile_image_2x:authors[n]?authors[n].querySelector('[data-scribe="element:avatar"]').getAttribute('data-src-2x'):null,screen_name:authors[n]?authors[n].querySelector('[data-scribe="element:screen_name"]').title:null,name:authors[n]?authors[n].querySelector('[data-scribe="element:name"]').title:null},time:times[n].textContent,timestamp:times[n].getAttribute('datetime').replace('+0000','Z').replace(/([\+\-])(\d\d)(\d\d)/,'$1$2:$3'),image:extractImageUrl(images[n]),rt:rts[n],tid:tids[n],permalinkURL:(permalinksURL[n]===undefined)?'':permalinksURL[n].href});n++;}}else{while(n<x){if(typeof(formatterFunction)!=='string'){var datetimeText=times[n].getAttribute('datetime');var newDate=new Date(times[n].getAttribute('datetime').replace(/-/g,'/').replace('T',' ').split('+')[0]);var dateString=formatterFunction(newDate,datetimeText);times[n].setAttribute('aria-label',dateString);if(tweets[n].textContent){if(supportsClassName){times[n].textContent=dateString;}else{var h=document.createElement('p');var t=document.createTextNode(dateString);h.appendChild(t);h.setAttribute('aria-label',dateString);times[n]=h;}}else{times[n].textContent=dateString;}}
var op='';if(parseLinks){if(targetBlank){targetLinksToNewWindow(tweets[n]);if(printUser){targetLinksToNewWindow(authors[n]);}}
if(printUser){op+='<div class="user">'+strip(authors[n].innerHTML)+'</div>';}
op+='<p class="tweet">'+strip(tweets[n].innerHTML)+'</p>';if(printTime){if(permalinks){op+='<p class="timePosted"><a href="'+permalinksURL[n]+'">'+times[n].getAttribute('aria-label')+'</a></p>';}else{op+='<p class="timePosted">'+
times[n].getAttribute('aria-label')+'</p>';}}}else{if(tweets[n].textContent){if(printUser){op+='<p class="user">'+authors[n].textContent+'</p>';}
op+='<p class="tweet">'+tweets[n].textContent+'</p>';if(printTime){op+='<p class="timePosted">'+times[n].textContent+'</p>';}}else{if(printUser){op+='<p class="user">'+authors[n].textContent+'</p>';}
op+='<p class="tweet">'+tweets[n].textContent+'</p>';if(printTime){op+='<p class="timePosted">'+times[n].textContent+'</p>';}}}
if(showInteractionLinks){op+='<p class="interact"><a href="https://twitter.com/intent/'+'tweet?in_reply_to='+tids[n]+'" class="twitter_reply_icon"'+
(targetBlank?' target="_blank">':'>')+'Reply</a><a href="https://twitter.com/intent/retweet?'+'tweet_id='+tids[n]+'" class="twitter_retweet_icon"'+
(targetBlank?' target="_blank">':'>')+'Retweet</a>'+'<a href="https://twitter.com/intent/favorite?tweet_id='+
tids[n]+'" class="twitter_fav_icon"'+
(targetBlank?' target="_blank">':'>')+'Favorite</a></p>';}
if(showImages&&images[n]!==undefined&&extractImageUrl(images[n])!==undefined){op+='<div class="media">'+'<img src="'+extractImageUrl(images[n])+'" alt="Image from tweet" />'+'</div>';}
if(showImages){arrayTweets.push(op);}else if(!showImages&&tweets[n].textContent.length){arrayTweets.push(op);}
n++;}}
handleTweets(arrayTweets);inProgress=false;if(queue.length>0){twitterFetcher.fetch(queue[0]);queue.splice(0,1);}}};window.__twttrf=twitterFetcher;window.twitterFetcher=twitterFetcher;return twitterFetcher;}));

;



/*!
 * pxs-map v2.0.0
 * (c) 2018 undefined
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('jquery')) :
	typeof define === 'function' && define.amd ? define(['jquery'], factory) :
	(global.PxsMap = factory(global.$));
}(this, (function ($) { 'use strict';

$ = $ && $.hasOwnProperty('default') ? $['default'] : $;

var justDebounce = debounce;

function debounce(fn, delay, at_start, guarantee) {
  var timeout;
  var args;
  var self;

  return function debounced() {
    self = this;
    args = Array.prototype.slice.call(arguments);

    if (timeout && (at_start || guarantee)) {
      return;
    } else if (!at_start) {
      clear();

      timeout = setTimeout(run, delay);
      return timeout;
    }

    timeout = setTimeout(clear, delay);
    fn.apply(self, args);

    function run() {
      clear();
      fn.apply(self, args);
    }

    function clear() {
      clearTimeout(timeout);
      timeout = null;
    }
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var PxsMap = function () {
  function PxsMap(section) {
    var _this = this;

    classCallCheck(this, PxsMap);

    this.$el = $('[data-map]', section.el);
    this.settings = section.data;
    this.map = null;
    this.center = null;

    this.$container = $('[data-map-container]', this.$el);

    // Scale so range is 12 ~ 17, rather than 1 to 6
    this.zoom = 11 + parseInt(this.settings.zoom, 10);
    if (isNaN(this.zoom)) this.zoom = 13;

    this.colors = null;

    if (this.settings.colors) {
      this.colors = this.settings.colors;
    }

    this.resize = this.resize.bind(this);

    this.address = this.settings.address;
    this.apiKey = this.settings.api_key;

    if (this.apiKey) {
      if (window.googleMaps === undefined) {
        window.googleMaps = true;

        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + this.apiKey).done(function () {
          _this._createMap();
        }).fail(function (status) {
          console.error(status);
        });
      } else {
        this._createMap();
      }
    }
  }

  createClass(PxsMap, [{
    key: '_createMap',
    value: function _createMap() {
      var _this2 = this;

      return this.geolocate().done(function (results) {
        _this2.map = new google.maps.Map(_this2.$container.get(0), {
          center: results[0].geometry.location,
          clickableIcons: false,
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          gestureHandling: 'none',
          keyboardShortcuts: false,
          maxZoom: _this2.zoom,
          minZoom: _this2.zoom,
          scrollWheel: false,
          styles: _this2._getMapStyles(),
          zoom: _this2.zoom,
          zoomControl: false
        });
        _this2.center = _this2.map.getCenter();
        _this2.map.panBy(0, 0);

        new google.maps.Marker({
          clickable: false,
          map: _this2.map,
          position: _this2.center
        });

        google.maps.event.addDomListener(window, 'resize', justDebounce(_this2.resize, 250, true, true));
      }).fail(function (status) {
        var usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
        var errorMessage = void 0;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = '<p>Unable to find the address:</p> ' + _this2.address;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = '\n              <p>Unable to load Google Maps, you have reached your usage limit.</p>\n              <p>\n                Please visit\n                <a href="' + usageLimits + '" target="_blank">' + usageLimits + '</a>\n                for more details.\n              </p>\n            ';
            break;
          default:
            errorMessage = 'Unable to load Google Maps.';
            break;
        }

        _this2.displayErrorInThemeEditor(errorMessage, status);
      });
    }
  }, {
    key: 'geolocate',
    value: function geolocate() {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: this.address }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }

        deferred.resolve(results);
      });

      return deferred;
    }
  }, {
    key: 'resize',
    value: function resize() {
      if (this.map) {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(this.center);
        this.map.panBy(0, 100);
      }
    }
  }, {
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      if (this.map) {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  }, {
    key: '_getMapStyles',
    value: function _getMapStyles() {
      if (!this.colors) {
        return;
      }

      return [{ elementType: 'geometry', stylers: [{ color: this.colors.e }] }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { elementType: 'labels.text.fill', stylers: [{ color: this.colors.a }] }, { elementType: 'labels.text.stroke', stylers: [{ color: this.colors.e }] }, { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.country', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.neighborhood', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.locality', stylers: [{ visibility: 'off' }] }, { featureType: 'poi', stylers: [{ visibility: 'off' }] }, { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: this.colors.d }] }, { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: this.colors.c }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: this.colors.b }] }, { featureType: 'road.highway.controlled_access', stylers: [{ visibility: 'off' }] }, { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: this.colors.b }] }, { featureType: 'road.local', elementType: 'labels.text.stroke', stylers: [{ color: this.colors.e }] }, { featureType: 'transit', stylers: [{ visibility: 'off' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: this.colors.f }] }];
    }
  }, {
    key: 'displayErrorInThemeEditor',
    value: function displayErrorInThemeEditor(errorMessage) {
      var isThemeEditor = window.Shopify && window.Shopify.designMode;

      if (!isThemeEditor) {
        return;
      }

      this.$container.html('<div class="map-error-message">' + errorMessage + '</div>');
    }
  }]);
  return PxsMap;
}();

return PxsMap;

})));

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observering a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    this.intersectionRatio = intersectionArea / targetArea;
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibilty state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its executiong, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child elemnt (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));

/*!
 * rimg v2.1.0
 * (c) 2018 Pixel Union
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.rimg = factory());
}(this, (function () { 'use strict';

/**
 * The default template render function. Turns a template string into an image
 * URL.
 *
 * @param {String} template
 * @param {Size} size
 * @returns {String}
 */
function defaultTemplateRender(template, size) {
  return template.replace('{size}', size.width + 'x' + size.height);
}

/**
 * @type Settings
 */
var defaults = {
  scale: 1,
  template: false,
  templateRender: defaultTemplateRender,
  max: { width: Infinity, height: Infinity },
  round: 32,
  placeholder: false
};

/**
 * Get a data attribute value from an element, with a default fallback and
 * sanitization step.
 *
 * @param {Element} el
 *
 * @param {String} name
 *        The data attribute name.
 *
 * @param {Object} options
 *        An object holding fallback values if the data attribute does not
 *        exist. If this object doesn't have the property, we further fallback
 *        to our defaults.
 *
 * @param {Function} [sanitize]
 *        A function to sanitize the data attribute value with.
 *
 * @returns {String|*}
 */
function getData(el, name, options, sanitize) {
  var attr = 'data-rimg-' + name;
  if (!el.hasAttribute(attr)) return options[name] || defaults[name];

  var value = el.getAttribute(attr);

  return sanitize ? sanitize(value) : value;
}

/**
 * Sanitize data attributes that represent a size (in the form of `10x10`).
 *
 * @param {String} value
 * @returns {Object} An object with `width` and `height` properties.
 */
function parseSize(value) {
  value = value.split('x');
  return { width: parseInt(value[0], 10), height: parseInt(value[1], 10) };
}

/**
 * Loads information about an element.
 *
 * Options can be set on the element itself using data attributes, or through
 * the `options` parameter. Data attributes take priority.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 * @returns {Item}
 */
function parseItem(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var isImage = el.hasAttribute('data-rimg-template');

  /**
   * @typedef {Settings} Item
   */
  return {
    el: el,

    // Type of element
    isImage: isImage,
    isBackgroundImage: isImage && el.tagName !== 'IMG',

    // Image scale
    scale: getData(el, 'scale', options),

    // Device density
    density: window.devicePixelRatio || 1,

    // Image template URL
    template: getData(el, 'template', options),
    templateRender: options.templateRender || defaults.templateRender,

    // Maximum image dimensions
    max: getData(el, 'max', options, parseSize),

    // Round image dimensions to the nearest multiple
    round: getData(el, 'round', options),

    // Placeholder image dimensions
    placeholder: getData(el, 'placeholder', options, parseSize)
  };
}

/**
 * Round to the nearest multiple.
 *
 * This is so we don't tax the image server too much.
 *
 * @param {Number} size The size, in pixels.
 * @param {Number} multiple The multiple to round to the nearest.
 * @returns {Number}
 */
function roundSize(size, multiple) {
  return Math.ceil(size / multiple) * multiple;
}

/**
 * Get the size of an element.
 *
 * If it is too small, it's parent element is checked, and so on. This helps
 * avoid the situation where an element doesn't have a size yet or is positioned
 * out of the layout.
 *
 * @param {HTMLElement} el
 * @return {Object} size
 * @return {Number} size.width The width, in pixels.
 * @return {Number} size.height The height, in pixels.
 */
function getElementSize(el) {
  var size = { width: 0, height: 0 };

  while (el) {
    size.width = el.offsetWidth;
    size.height = el.offsetHeight;
    if (size.width > 20 && size.height > 20) break;
    el = el.parentNode;
  }

  return size;
}

/**
 * Trigger a custom event.
 *
 * Note: this approach is deprecated, but still required to support older
 * browsers such as IE 10.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 *
 * @param {HTMLElement} el
 *        The element to trigger the event on.
 *
 * @param {String} name
 *        The event name.
 *
 * @returns {Boolean}
 *          True if the event was canceled.
 */
function trigger(el, name) {
  var event = document.createEvent('Event');
  event.initEvent(name, true, true);
  return !el.dispatchEvent(event);
}

/**
 * Return the maximum supported density of the image, given the container.
 *
 * @param {Item} item
 * @param {Size} size
 */
function supportedDensity(item, size) {
  return Math.min(Math.min(Math.max(item.max.width / size.width, 1), item.density), Math.min(Math.max(item.max.height / size.height, 1), item.density)).toFixed(2);
}

/**
 * Set the image URL on the element. Supports background images and `srcset`.
 *
 * @param {Item} item
 * @param {Size} size
 * @param {Boolean} isPlaceholder
 */
function setImage(item, size, isPlaceholder, onLoad) {
  var render = item.templateRender;
  var density = isPlaceholder ? 1 : supportedDensity(item, size);
  var round = isPlaceholder ? 1 : item.round;

  var width = roundSize(size.width * density, round);
  var height = roundSize(size.height * density, round);
  var displaySize = width > item.max.width || height > item.max.height ? { width: item.max.width, height: item.max.height } : { width: width, height: height };

  var url = render(item.template, displaySize);

  // On load callback
  var image = new Image();
  image.onload = onLoad;
  image.src = url;

  // Set image
  if (item.isBackgroundImage) {
    item.el.style.backgroundImage = 'url(\'' + url + '\')';
  } else {
    item.el.setAttribute('srcset', url + ' ' + density + 'x');
  }
}

/**
 * Load the image, set loaded status, and trigger the load event.
 *
 * @fires rimg:load
 * @fires rimg:error
 * @param {Item} item
 * @param {Size} size
 */
function loadFullImage(item, size) {
  var el = item.el;

  setImage(item, size, false, function (event) {
    if (event.type === 'load') {
      el.setAttribute('data-rimg', 'loaded');
    } else {
      el.setAttribute('data-rimg', 'error');
      trigger(el, 'rimg:error');
    }

    trigger(el, 'rimg:load');
  });
}

/**
 * Load in a responsive image.
 *
 * Sets the image's `srcset` attribute to the final image URLs, calculated based
 * on the actual size the image is being shown at.
 *
 * @fires rimg:loading
 *        The image URLs have been set and we are waiting for them to load.
 *
 * @fires rimg:loaded
 *        The final image has loaded.
 *
 * @fires rimg:error
 *        The final image failed loading.
 *
 * @param {Item} item
 */
function loadImage(item) {
  var el = item.el;

  // Already loaded?
  var status = el.getAttribute('data-rimg');
  if (status === 'loading' || status === 'loaded') return;

  // Is the SVG loaded?
  if (!el.complete && !item.isBackgroundImage) {
    // Wait for the load event, then call load image
    el.addEventListener('load', function cb() {
      el.removeEventListener('load', cb);
      loadImage(item);
    });

    return;
  }

  // Trigger loading event, and stop if cancelled
  if (trigger(el, 'rimg:loading')) return;

  // Mark as loading
  el.setAttribute('data-rimg', 'loading');

  // Get element size. This is used as the ideal display size.
  var size = getElementSize(item.el);

  size.width *= item.scale;
  size.height *= item.scale;

  if (item.placeholder) {
    // Load a placeholder image first, followed by the full image. Force the
    // element to keep its dimensions while it loads. If the image is smaller
    // than the element size, use the image's size. Density is taken into account
    // for HiDPI devices to avoid blurry images.
    if (!item.isBackgroundImage) {
      el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
      el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
    }

    setImage(item, item.placeholder, true, function () {
      return loadFullImage(item, size);
    });
  } else {
    loadFullImage(item, size);
  }
}

/**
 * Prepare an element to be displayed on the screen.
 *
 * Images have special logic applied to them to swap out the different sources.
 *
 * @fires rimg:enter
 *        The element is entering the viewport.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 */
function load(el, options) {
  if (!el) return;
  trigger(el, 'rimg:enter');

  var item = parseItem(el, options);
  if (item.isImage) {
    if (!item.isBackgroundImage) {
      el.setAttribute('data-rimg-template-svg', el.getAttribute('srcset'));
    }

    loadImage(item);
  }
}

/**
 * Prepare an element to be displayed on the screen.
 *
 * Images have special logic applied to them to swap out the different sources.
 *
 * @fires rimg:enter
 *        The element is entering the viewport.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 */
function update(el, options) {
  if (!el) return;
  trigger(el, 'rimg:update');

  var item = parseItem(el, options);

  if (item.isImage) {
    if (!item.isBackgroundImage) {
      el.setAttribute('data-rimg', 'lazy');
      el.setAttribute('srcset', el.getAttribute('data-rimg-template-svg'));
    }

    loadImage(item);
  }
}

/**
 * @typedef {Object} Size
 * @property {Number} width
 * @property {Number} height
 */

/**
 * A function to turn a template string into a URL.
 *
 * @callback TemplateRenderer
 * @param {String} template
 * @param {Size} size
 * @returns {String}
 */

/**
 * @typedef {Object} Settings
 *
 * @property {String} [template]
 *           A template string used to generate URLs for an image. This allows us to
 *           dynamically load images with sizes to match the container's size.
 *
 * @property {TemplateRenderer} [templateRender]
 *           A function to turn a template string into a URL.
 *
 * @property {Size} [max]
 *           The maximum available size for the image. This ensures we don't
 *           try to load an image larger than is possible.
 *
 * @property {Number} [round]
 *           Round image dimensions to the nearest multiple. This is intended to
 *           tax the image server less by lowering the number of possible image
 *           sizes requested.
 *
 * @property {Size} [placeholder]
 *           The size of the lo-fi image to load before the full image.
 */

/**
 * Initialize the responsive image handler.
 *
 * @param {String|HTMLElement|NodeList} selector
 *        The CSS selector, element, or elements to track for lazy-loading.
 *
 * @param {Settings} options
 *
 * @returns {PublicApi}
 */
function rimg() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Intersections
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        io.unobserve(entry.target);
        load(entry.target, options);
      }
    });
  }, {
    // Watch the viewport, with 20% vertical margins
    rootMargin: '20% 0px'
  });

  /**
   * @typedef {Object} PublicApi
   */
  var api = {
    /**
     * Track a new selector, element, or nodelist for lazy-loading.
     * @type Function
     * @param {String|HTMLElement|NodeList} selector
     */
    track: function track() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';

      var els = querySelector(selector);
      for (var i = 0; i < els.length; i++) {
        io.observe(els[i]);
      }
    },
    update: function update$$1() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="loaded"]';

      var els = querySelector(selector);
      for (var i = 0; i < els.length; i++) {
        update(els[i], options);
      }
    },


    /**
     * Stop tracking element(s) for lazy-loading.
     * @type Function
     * @param {String|HTMLElement|NodeList} selector
     */
    untrack: function untrack() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';

      var els = querySelector(selector);
      for (var i = 0; i < els.length; i++) {
        io.unobserve(els[i]);
      }
    },


    /**
     * Unload all event handlers and observers.
     * @type Function
     */
    unload: function unload() {
      io.disconnect();
    }
  };

  // Add initial elements
  api.track(selector);

  return api;
}

/**
 * Finds a group of elements on the page.
 *
 * @param {String|HTMLElement|NodeList} selector
 * @returns {Object} An array-like object.
 */
function querySelector(selector) {
  if (typeof selector === 'string') {
    return document.querySelectorAll(selector);
  }

  if (selector instanceof HTMLElement) {
    return [selector];
  }

  if (selector instanceof NodeList) {
    return selector;
  }

  return [];
}

return rimg;

})));

/*!
 * rimg-shopify v2.2.0
 * (c) 2018 Pixel Union
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('rimg')) :
	typeof define === 'function' && define.amd ? define(['rimg'], factory) :
	(global.rimg = global.rimg || {}, global.rimg.shopify = factory(global.rimg));
}(this, (function (rimg) { 'use strict';

rimg = rimg && rimg.hasOwnProperty('default') ? rimg['default'] : rimg;

/**
 * Polyfill for Element.matches().
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
    while (--i >= 0 && matches.item(i) !== this) {}
    return i > -1;
  };
}

var state = {
  init: init,
  watch: watch,
  unwatch: unwatch
};

function init() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  state.selector = selector;
  state.instance = rimg(selector, options);
  state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  // Listen for Shopify theme editor events
  document.addEventListener('shopify:section:load', function (event) {
    return watch(event.target);
  });

  window.addEventListener('resize', function () {
    return _update();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    return unwatch(event.target);
  });

  // Listen for custom events to allow themes to hook into rimg
  document.addEventListener('theme:rimg:watch', function (event) {
    return watch(event.target);
  });

  document.addEventListener('theme:rimg:unwatch', function (event) {
    return unwatch(event.target);
  });

  // Support custom events triggered through jQuery
  // See: https://github.com/jquery/jquery/issues/3347
  if (window.jQuery) {
    jQuery(document).on({
      'theme:rimg:watch': function themeRimgWatch(event) {
        return watch(event.target);
      },
      'theme:rimg:unwatch': function themeRimgUnwatch(event) {
        return unwatch(event.target);
      }
    });
  }
}

/**
 * Track an element, and its children.
 *
 * @param {HTMLElement} el
 */
function watch(el) {
  // Track element
  if (typeof el.matches === 'function' && el.matches(state.selector)) {
    state.instance.track(el);
  }

  // Track element's children
  state.instance.track(el.querySelectorAll(state.selector));
}

/**
 * Untrack an element, and its children
 *
 * @param {HTMLElement} el
 * @private
 */
function unwatch(el) {
  // Untrack element's children
  state.instance.untrack(el.querySelectorAll(state.selector));

  // Untrack element
  if (typeof el.matches === 'function' && el.matches(state.selector)) {
    state.instance.untrack(el);
  }
}

/**
 * Update an element, and its children.
 *
 * @param {HTMLElement} el
 */
function _update() {
  var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  // Return if we're not 2x smaller, or larger than the existing loading size
  if (currentWidth / state.loadedWidth > 0.5 && currentWidth / state.loadedWidth < 2) {
    return;
  }

  state.loadedWidth = currentWidth;
  state.instance.update();
}

return state;

})));

;

$(function() {
  return new ThemeView();
});

WINDOW = $(window);

BODY = $('body');

TOUCH = $('html').hasClass('touch');

window.themeUtils = {
  debounce: function(func, wait, immediate) {
    var timeout;
    timeout = void 0;
    return function() {
      var args, callNow, context, later;
      context = this;
      args = arguments;
      later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  }
};

ThemeView = (function(superClass) {
  extend(ThemeView, superClass);

  function ThemeView() {
    return ThemeView.__super__.constructor.apply(this, arguments);
  }

  ThemeView.prototype.el = document.body;

  ThemeView.prototype.events = {
    'focus .field': 'removeErrors',
    'submit .comment-form': 'spamCheck',
    'submit .contact-form': 'spamCheck'
  };

  ThemeView.prototype.initialize = function() {
    var j, len, ref, rte;
    this.render();
    this.customerPage = this.$el.attr('class').indexOf('customer') > 0;
    if (navigator.userAgent.indexOf('MSIE 10.0') > 0) {
      $('html').addClass('ie10');
    }
    if ($('html').hasClass('lt-ie10')) {
      this.inputPlaceholderFix();
    }
    ref = $('.rte');
    for (j = 0, len = ref.length; j < len; j++) {
      rte = ref[j];
      new RTEView({
        el: $(rte)
      });
    }
    new QuickShopView();
    new HeaderView({
      el: this.$el
    });
    rimg.shopify.init();
    if (BODY.hasClass('template-index')) {
      new IndexView({
        el: this.$el
      });
    }
    if (BODY.hasClass('template-collection')) {
      new CollectionView({
        el: this.$el
      });
    }
    if (BODY.hasClass('template-list-collections')) {
      new ListCollectionsView({
        el: this.$el
      });
    }
    if (BODY.hasClass('gift-card-template')) {
      new GiftCardView({
        el: this.$el
      });
    }
    if ($('.content-area').hasClass('customer')) {
      return new AccountView({
        el: this.$el
      });
    }
  };

  ThemeView.prototype.render = function() {
    this.sections = new ThemeEditor();
    this.sections.register('slider', this.slider(this.sections));
    this.sections.register('collection-list', this.collectionList(this.sections));
    this.sections.register('instagram-feed', this.instagram(this.sections));
    this.sections.register('twitter-feed', this.twitter(this.sections));
    this.sections.register('featured-video', this.video(this.sections));
    this.sections.register('featured-product', this.product(this.sections));
    this.sections.register('template-product', this.product(this.sections));
    this.sections.register('pxs-map', this.map(this.sections));
    if (BODY.hasClass('template-article')) {
      new SharingWidgetView({
        el: this.$el
      });
    }
    if (BODY.hasClass('template-cart')) {
      new CartView({
        el: this.$el
      });
    }
    if (BODY.hasClass('template-password')) {
      return new PasswordView({
        el: this.$el
      });
    }
  };

  ThemeView.prototype.slider = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new SlideshowView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        var instance;
        instance = sections.getInstance(event);
        return this.onSectionSelect(instance);
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      },
      onBlockSelect: function(event) {
        var instanceHandler;
        instanceHandler = this.instances[sections.getInstance(event).sectionId];
        return instanceHandler.lockSlide(event);
      },
      onBlockDeselect: function(event) {
        var instanceHandler;
        instanceHandler = this.instances[sections.getInstance(event).sectionId];
        return instanceHandler.unlockSlide();
      }
    };
  };

  ThemeView.prototype.collectionList = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new CollectionListView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        var instance;
        instance = sections.getInstance(event);
        return this.onSectionSelect(instance);
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.instagram = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new InstagramView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        var instance;
        instance = sections.getInstance(event);
        return this.onSectionSelect(instance);
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.twitter = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new TwitterView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        var instance;
        instance = sections.getInstance(event);
        return this.onSectionSelect(instance);
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.video = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new VideoView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        var instance;
        instance = sections.getInstance(event);
        return this.onSectionSelect(instance);
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.product = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new ProductView({
          el: instance.el,
          data: instance.data
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionUnload: function(event) {
        var instance;
        instance = sections.getInstance(event);
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.map = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new PxsMap({
          el: instance.el,
          data: instance.data
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (!this.instances[instance.sectionId]) {
          return this.init(instance);
        }
      },
      onSectionUnload: function(event) {
        var instance;
        instance = sections.getInstance(event);
        this.instances[instance.sectionId].onSectionUnload();
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.removeErrors = function(e) {
    var field;
    field = $(e.currentTarget);
    return field.removeClass('error');
  };

  ThemeView.prototype.inputPlaceholderFix = function() {
    var input, j, len, placeholders, text;
    placeholders = $('[placeholder]');
    for (j = 0, len = placeholders.length; j < len; j++) {
      input = placeholders[j];
      input = $(input);
      if (!(input.attr('value').length > 0)) {
        text = input.attr('placeholder');
        input.attr('value', text);
        input.data('original-text', text);
      }
    }
    placeholders.focus(function() {
      input = $(this);
      if (input.val() === input.data('original-text')) {
        return input.val('');
      }
    });
    return placeholders.blur(function() {
      input = $(this);
      if (input.val().length === 0) {
        return input.val(input.data('original-text'));
      }
    });
  };

  ThemeView.prototype.spamCheck = function(e) {
    if (this.$(e.target).find('.comment-check').val().length > 0) {
      return e.preventDefault();
    }
  };

  return ThemeView;

})(Backbone.View);

HeaderView = (function(superClass) {
  extend(HeaderView, superClass);

  function HeaderView() {
    this.toggleStickyMobileNav = bind(this.toggleStickyMobileNav, this);
    this.toggleStickyDesktopNav = bind(this.toggleStickyDesktopNav, this);
    return HeaderView.__super__.constructor.apply(this, arguments);
  }

  HeaderView.prototype.el = $('.main-header');

  HeaderView.prototype.events = {
    'click .main-header--tools .search': 'toggleSearch',
    'blur .main-header--tools .search-input': 'toggleSearch',
    'click .compact .search': 'toggleMobileSearch',
    'blur .compact .search-input': 'toggleMobileSearch',
    'click .mini-cart-wrap': 'toggleMiniCart',
    'click .mini-cart.active': 'stopProp',
    'change [name=currencies]': 'switchCurrency',
    'switch-currency': 'switchCurrency',
    'position-body-offset': 'positionBodyOffset'
  };

  HeaderView.prototype.initialize = function() {
    this.sectionBinding();
    this.initializedClass = 'header-initialized';
    this._validate();
    return $(document).on("navigation-resize.header", (function(_this) {
      return function(e) {
        return _this.positionBodyOffset();
      };
    })(this));
  };

  HeaderView.prototype.prepareRemove = function() {
    return $(document).off(".header");
  };

  HeaderView.prototype._initializeCurrency = function() {
    var newCurrency;
    Currency.format = Theme.currencySwitcherFormat;
    Currency.money_with_currency_format = {};
    Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
    Currency.money_format = {};
    Currency.money_format[Theme.currency] = Theme.moneyFormat;
    newCurrency = Currency.cookie.read();
    if (newCurrency && this.$("[name=currencies] option[value=" + newCurrency + "]")) {
      Currency.currentCurrency = newCurrency;
    } else if (Theme.defaultCurrency) {
      Currency.currentCurrency = Theme.defaultCurrency;
      Currency.cookie.write(Theme.defaultCurrency);
    } else {
      Currency.currentCurrency = Theme.currency;
      Currency.cookie.write(Theme.currency);
    }
    $("[name=currencies]").val(Currency.currentCurrency);
    $(window).load((function(_this) {
      return function() {
        var doubleMoney, j, l, len, len1, money, ref, ref1, results;
        ref = $("span.money span.money");
        for (j = 0, len = ref.length; j < len; j++) {
          doubleMoney = ref[j];
          $(doubleMoney).parents("span.money").removeClass("money");
        }
        ref1 = $("span.money");
        results = [];
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          money = ref1[l];
          results.push($(money).attr("data-currency-" + Theme.currency, $(money).html()));
        }
        return results;
      };
    })(this));
    if (Theme.currencySwitcher) {
      return this.switchCurrency();
    }
  };

  HeaderView.prototype._validate = function() {
    this.headerSettings = window.headerJSON;
    this.window = $(window);
    this.body = $('body');
    this.mainHeader = $('.main-header');
    this.minimalHeader = $('.header-minimal');
    this.mainHeaderWrap = $('.main-header-wrap');
    this.fullNav = $('nav.full', this.$el);
    this.compactNav = $('nav.compact', this.$el);
    this.slideshow = $('.slideshow', this.$el);
    this.actionLinks = $('.main-header .action-links');
    this.tools = $('.tools');
    this.toolsGroup = $('.main-header--tools-group');
    this.branding = $('.store-title, .logo');
    this.searchWrap = $('.main-header--tools .search-wrap');
    this.mobileSearchWrap = $('.compact .search-outer-wrap');
    this.searchInput = $('.search-input');
    this.miniCart = $('.mini-cart');
    this.bodyContent = $('.page-body-content');
    if (!this.body.hasClass('template-password')) {
      this._initializeCurrency();
    }
    if (!this.body.hasClass('template-index' && this.slideshow.length && this.slideshow.attr('data-full-width') === 'true')) {
      if (this.compactNav.length) {
        this.compactNav.addClass('bordered');
      } else {
        this.compactNav.removeClass('bordered');
      }
      if (this.fullNav.length) {
        this.fullNav.addClass('bordered');
      } else {
        this.fullNav.removeClass('bordered');
      }
    }
    if (this.mainHeaderWrap.attr('data-header-alignment') === 'true') {
      this.tools = $('.main-header--tools-left');
    }
    this.positionBodyOffset();
    $('body').click((function(_this) {
      return function(e) {
        if (_this.miniCart.hasClass('active')) {
          _this.miniCart.hide().removeClass('active');
          return _this.miniCart.parent().removeClass('active');
        }
      };
    })(this));
    this.window.on('scroll', window.themeUtils.debounce(this.toggleStickyMobileNav, 15));
    this.window.on('scroll', this.toggleStickyDesktopNav);
    this.window.resize((function(_this) {
      return function() {
        _this.resize();
        if (_this.mainHeaderWrap.attr('data-header-format') === 'minimal') {
          _this.positionBodyOffset();
          _this.toggleStickyMobileNav();
          return _this.toggleStickyDesktopNav();
        }
      };
    })(this));
    this.toggleStickyDesktopNav();
    return this.NavigationView = new NavigationView({
      el: 'nav.full'
    });
  };

  HeaderView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-header')) {
          return;
        }
        _this.delegateEvents();
        return _this._validate();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function(event) {
        var ref, ref1;
        if (!$(event.target).hasClass('section-header')) {
          return;
        }
        _this.undelegateEvents();
        if ((ref = _this.NavigationView) != null) {
          ref.prepareRemove();
        }
        return (ref1 = _this.NavigationView) != null ? ref1.remove() : void 0;
      };
    })(this));
  };

  HeaderView.prototype.stopProp = function(e) {
    return e.stopPropagation();
  };

  HeaderView.prototype.resize = function() {
    if (this.window.width() < 720) {
      return this.searchWrap.hide();
    }
  };

  HeaderView.prototype.positionBodyOffset = function() {
    if (this.mainHeaderWrap.attr('data-header-format') === 'minimal') {
      if (this.window.width() < 720) {
        return;
      }
      return this.bodyContent.delay(3000).css({
        marginTop: this.mainHeader.outerHeight()
      });
    } else {
      return this.bodyContent.css({
        marginTop: ""
      });
    }
  };

  HeaderView.prototype.toggleStickyDesktopNav = function() {
    if ($('.pxs-announcement-bar').length !== 0) {
      if (!(WINDOW.width() > 720)) {
        return;
      }
      if (this.mainHeaderWrap.attr('data-header-format') !== 'minimal') {
        return;
      }
      if (this.window.scrollTop() > $('.pxs-announcement-bar').outerHeight()) {
        this.mainHeaderWrap.css({
          position: 'fixed',
          top: 0
        });
        return this.bodyContent.css({
          marginTop: 0
        });
      } else {
        this.mainHeaderWrap.css({
          position: 'absolute',
          top: $('.pxs-announcement-bar').outerHeight()
        });
        return this.bodyContent.css({
          marginTop: 0
        });
      }
    }
  };

  HeaderView.prototype.toggleStickyMobileNav = function() {
    if (!(WINDOW.width() < 720)) {
      return;
    }
    if (this.mainHeaderWrap.attr('data-header-format') !== 'minimal') {
      return;
    }
    if (this.window.scrollTop() > this.minimalHeader.outerHeight() + $('.pxs-announcement-bar').outerHeight()) {
      this.mainHeaderWrap.addClass('header-mobile-stick').css({
        position: '',
        top: 0
      });
      return this.bodyContent.css({
        marginTop: $('.main-header .compact').outerHeight()
      });
    } else {
      this.mainHeaderWrap.removeClass('header-mobile-stick').css({
        position: '',
        top: 0
      });
      return this.bodyContent.css({
        marginTop: 0
      });
    }
  };

  HeaderView.prototype.toggleSearch = function() {
    if (this.searchWrap.hasClass('active')) {
      this.searchWrap.hide().removeClass('active');
      this.searchInput.val('');
    } else {
      this.searchWrap.show().addClass('active');
      this.searchInput.focus();
      this.miniCart.hide().removeClass('active');
      this.miniCart.parent().removeClass('active');
    }
    return false;
  };

  HeaderView.prototype.toggleMobileSearch = function() {
    var offset;
    if (this.mobileSearchWrap.hasClass('active')) {
      this.mobileSearchWrap.hide().removeClass('active');
      return this.searchInput.val('');
    } else {
      this.mobileSearchWrap.show().addClass('active');
      offset = this.mobileSearchWrap.find('.search-wrap').outerHeight() / -2;
      this.mobileSearchWrap.find('.search-wrap').css({
        marginTop: offset
      });
      this.searchInput.focus();
      return $('.mobile-dropdown').trigger('close-mobile-nav');
    }
  };

  HeaderView.prototype.toggleMiniCart = function(e) {
    var button;
    button = this.miniCart.parent();
    if (this.miniCart.hasClass('active')) {
      this.miniCart.hide().removeClass('active');
      button.removeClass('active');
    } else {
      this.miniCart.show().addClass('active');
      button.addClass('active');
    }
    return e.stopPropagation();
  };

  HeaderView.prototype.switchCurrency = function(e) {
    var $switcher, j, len, money, newCurrency, ref;
    $switcher = $("[name=currencies]");
    newCurrency = $switcher.val();
    if (e !== void 0) {
      $switcher = $(e.currentTarget);
      if ($switcher !== void 0 && ($switcher != null ? $switcher.attr('name') : void 0) === 'currencies') {
        $("[name=currencies]").val($switcher.val());
        newCurrency = $switcher.val();
      }
    }
    if (newCurrency === null || newCurrency === '') {
      newCurrency = Theme.currency;
    }
    ref = $("span.money");
    for (j = 0, len = ref.length; j < len; j++) {
      money = ref[j];
      if ($(money).text() === "") {
        $(money).attr('data-orig-price', 'none');
      }
      $(money).toggleClass("no-price", $(money).text() === "");
      $(money).html($(money).attr("data-currency-" + Theme.currency));
      $(money).attr("data-currency", Theme.currency);
    }
    Currency.convertAll(Theme.currency, newCurrency);
    Currency.currentCurrency = newCurrency;
    Currency.cookie.write(newCurrency);
    return this.$(".selected-currency").text(Currency.currentCurrency);
  };

  return HeaderView;

})(Backbone.View);

NavigationView = (function(superClass) {
  extend(NavigationView, superClass);

  function NavigationView() {
    return NavigationView.__super__.constructor.apply(this, arguments);
  }

  NavigationView.prototype.events = {
    'mouseenter .dropdown': 'establishTierDirection',
    'mouseleave .dropdown': 'replaceTrailingDivider',
    'mouseenter .has-mega-nav': 'toggleMegaNav',
    'format-full-navigation': 'formatFullNavigation',
    'mouseenter [aria-haspopup]': 'setExpanded',
    'mouseleave [aria-haspopup]': 'unsetExpanded'
  };

  NavigationView.prototype.initialize = function() {
    this.initializedClass = 'navigation-initialized';
    return this._validate();
  };

  NavigationView.prototype.setExpanded = function(e) {
    var $link;
    $link = $(e.currentTarget);
    return $link.attr("aria-expanded", true);
  };

  NavigationView.prototype.unsetExpanded = function(e) {
    var $link;
    $link = $(e.currentTarget);
    if ($link.hasClass("has-mega-nav")) {
      return;
    }
    return $link.attr("aria-expanded", false);
  };

  NavigationView.prototype._validate = function() {
    var j, len, navItem, ref;
    this.$mainHeader = $('.main-header');
    this.navigation = this.$mainHeader.find('nav.full');
    this.megaNavButton = this.navigation.find('.has-mega-nav');
    this.mainMenuNavItems = this.navigation.find('> ul > .nav-item');
    this.multiLine = false;
    this.checkIfFontsLoaded();
    this.requiredRoom = 0;
    ref = this.mainMenuNavItems;
    for (j = 0, len = ref.length; j < len; j++) {
      navItem = ref[j];
      navItem = $(navItem);
      this.requiredRoom += navItem.outerWidth();
    }
    this.MobileNavigationView = new MobileNavigationView({
      el: 'nav.compact'
    });
    this.megaNavs = [];
    $(".mega-nav").each((function(_this) {
      return function(index, el) {
        var $el, view;
        $el = $(el);
        view = new MegaNavigationView({
          el: $el
        });
        return _this.megaNavs.push({
          $el: $el,
          view: view,
          id: $el.attr("id")
        });
      };
    })(this));
    this.megaNavs.forEach((function(_this) {
      return function(nav) {
        return nav.$el.on("closeMegaNav.nav", function(e) {
          return _this.$(".dropdown[aria-controls='" + nav.id + "']").attr("aria-expanded", false);
        });
      };
    })(this));
    return WINDOW.resize((function(_this) {
      return function() {
        return _this.resize();
      };
    })(this));
  };

  NavigationView.prototype.prepareRemove = function() {
    this.MobileNavigationView.remove();
    return this.megaNavs.forEach((function(_this) {
      return function(nav) {
        nav.$el.off(".nav");
        return nav.view.remove();
      };
    })(this));
  };

  NavigationView.prototype.checkIfFontsLoaded = function() {
    var checker, hasRun;
    hasRun = 0;
    return checker = setInterval((function(_this) {
      return function() {
        hasRun += 1;
        if ($('html').hasClass('wf-active') || hasRun === 10) {
          _this.formatFullNavigation();
          return clearInterval(checker);
        }
      };
    })(this), 500);
  };

  NavigationView.prototype.replaceTrailingDivider = function(e) {
    var previousNavItem;
    return previousNavItem = ($(e.currentTarget)).prev();
  };

  NavigationView.prototype.resize = function() {
    return this.formatFullNavigation();
  };

  NavigationView.prototype.formatFullNavigation = function() {
    var availableRoom;
    if (this.navigation.hasClass("main-header--nav-compressed")) {
      return;
    }
    availableRoom = this.navigation.width();
    if (this.requiredRoom >= availableRoom) {
      this.navigation.addClass('compress');
      if (this.navigation.height() > 100) {
        this.multiLine = true;
        this.navigation.addClass('multi-line');
      } else {
        this.navigation.removeClass('multi-line');
        this.multiLine = false;
      }
    } else {
      this.navigation.removeClass('compress');
      this.navigation.removeClass('multi-line');
      this.multiLine = false;
    }
    this.$mainHeader.trigger('position-body-offset');
    return $(document).trigger("navigation-resize");
  };

  NavigationView.prototype.establishTierDirection = function(e) {
    var availableRoom, childWidth, children, dropdown, positionLeft, requiredRoom, secondaryChildren, tertiaryChildren;
    this.mainHeaderWrap = $(".main-header-wrap");
    dropdown = $(e.currentTarget);
    children = dropdown.find(".child");
    secondaryChildren = children.filter(".secondary");
    tertiaryChildren = children.filter(".tertiary");
    childWidth = dropdown.find(".dropdown-wrap").outerWidth();
    positionLeft = dropdown.position().left;
    requiredRoom = (tertiaryChildren.length > 0) ? 3 * childWidth : 2 * childWidth;
    availableRoom = $(window).width() - positionLeft - dropdown.outerWidth();
    if (requiredRoom > availableRoom) {
      children.removeClass("right").addClass("left");
    } else {
      children.removeClass("left").addClass("right");
    }
    return this.megaNavs.filter((function(_this) {
      return function(nav) {
        return dropdown.attr("aria-controls") !== nav.$el.attr("id");
      };
    })(this)).forEach((function(_this) {
      return function(nav) {
        return nav.$el.trigger("dismissMegaNav");
      };
    })(this));
  };

  NavigationView.prototype.toggleMegaNav = function(e) {
    var $target;
    $target = $(e.currentTarget);
    if ($target.hasClass("active")) {
      return;
    }
    this.megaNavs.filter((function(_this) {
      return function(nav) {
        return $target.attr("aria-controls") === nav.$el.attr("id");
      };
    })(this)).forEach((function(_this) {
      return function(nav) {
        return nav.$el.trigger("toggleMegaNav");
      };
    })(this));
    return false;
  };

  return NavigationView;

})(Backbone.View);

MobileNavigationView = (function(superClass) {
  extend(MobileNavigationView, superClass);

  function MobileNavigationView() {
    return MobileNavigationView.__super__.constructor.apply(this, arguments);
  }

  MobileNavigationView.prototype.el = $('.mobile-dropdown');

  MobileNavigationView.prototype.events = {
    'click .dropdown > a': 'toggleExpand',
    'close-mobile-nav': 'closeMobileNav'
  };

  MobileNavigationView.prototype.initialize = function() {
    this.mobileDropdownButton = $('.compact .nav-item.dropdown');
    this.mobileDropdown = $('.mobile-dropdown');
    this.$('.nav-item.dropdown').on('click', (function(_this) {
      return function() {
        return _this.toggleMobileNav();
      };
    })(this));
    this.windowWidth = $(window).width();
    return WINDOW.resize((function(_this) {
      return function() {
        _this.resize();
        return _this.windowWidth = $(window).width();
      };
    })(this));
  };

  MobileNavigationView.prototype.resize = function() {
    var isWidthIncrease;
    isWidthIncrease = this.windowWidth !== $(window).width() ? true : false;
    if (WINDOW.width() > 720 && this.mobileDropdownButton.hasClass('active') && isWidthIncrease) {
      return this.closeMobileNav();
    }
  };

  MobileNavigationView.prototype.openMobileNav = function() {
    this.mobileDropdownButton.addClass('active');
    this.mobileDropdownButton.attr("aria-expanded", true);
    return this.mobileDropdown.show();
  };

  MobileNavigationView.prototype.closeMobileNav = function() {
    this.mobileDropdownButton.removeClass('active');
    this.mobileDropdownButton.attr("aria-expanded", false);
    return this.mobileDropdown.hide();
  };

  MobileNavigationView.prototype.closeAll = function(except) {
    return except.siblings(".expanded").each((function(_this) {
      return function(index, el) {
        var $el;
        $el = $(el);
        $el.closest("li.list-item").removeClass("expanded");
        return $el.find("> .list").hide();
      };
    })(this));
  };

  MobileNavigationView.prototype.toggleMobileNav = function() {
    if (this.mobileDropdownButton.hasClass('active')) {
      return this.closeMobileNav();
    } else {
      return this.openMobileNav();
    }
  };

  MobileNavigationView.prototype.toggleExpand = function(e) {
    var button, childList, isExpanded, isIcon, listItem;
    button = ($(e.currentTarget)).parent();
    listItem = button.closest("li.list-item");
    childList = button.find("> .list");
    isIcon = $(e.target).hasClass("icon");
    isExpanded = listItem.hasClass("expanded");
    if (isExpanded && !isIcon) {
      return;
    }
    e.preventDefault();
    this.closeAll(button);
    listItem.toggleClass("expanded");
    childList.toggle();
    return listItem.attr("aria-expanded", listItem.hasClass("expanded"));
  };

  return MobileNavigationView;

})(Backbone.View);

MegaNavigationView = (function(superClass) {
  extend(MegaNavigationView, superClass);

  function MegaNavigationView() {
    return MegaNavigationView.__super__.constructor.apply(this, arguments);
  }

  MegaNavigationView.prototype.initialize = function() {
    this.initializedClass = 'mega-navigation-initialized';
    return this._validate();
  };

  MegaNavigationView.prototype._validate = function() {
    var listCount;
    this.navContainer = $('nav.full');
    this.nav = this.$el;
    this.trigger = this.nav.attr("id");
    this.megaNavWrap = this.nav.find('.mega-nav-wrap');
    this.navTrigger = $("[aria-controls=" + this.trigger + "]");
    this.mainList = this.$el.find('.main-list');
    this.expandedList = this.$el.find('.expanded-list');
    this.categoriesList = this.$el.find('.category-list');
    this.backButton = this.$el.find('.back');
    listCount = this.mainList.find('.list').length;
    if (listCount === 1) {
      listCount = 'one-col';
    }
    if (listCount === 2) {
      listCount = 'two-col';
    }
    if (listCount === 3) {
      listCount = 'three-col';
    }
    this.mainList.find('.list').addClass(listCount);
    this.nav.css({
      height: this.megaNavWrap.height()
    });
    WINDOW.resize((function(_this) {
      return function() {
        return _this.resize();
      };
    })(this));
    return $('.has-mega-nav, .mega-nav').mouseleave((function(_this) {
      return function(e) {
        return _this.closeMegaNav(e);
      };
    })(this));
  };

  MegaNavigationView.prototype.events = {
    'toggleMegaNav': 'toggle',
    'dismissMegaNav': 'dismiss',
    'click .show-more': 'goDeepWithin',
    'click .back': 'reset'
  };

  MegaNavigationView.prototype.resize = function() {
    this.nav.css({
      height: this.megaNavWrap.height()
    });
    if (WINDOW.width() < 720) {
      return this.dismiss();
    } else if (this.navTrigger.hasClass('active')) {
      return this.invoke();
    }
  };

  MegaNavigationView.prototype.toggle = function() {
    if (this.navTrigger.hasClass('active')) {
      this.dismiss();
    } else {
      this.invoke();
    }
    return false;
  };

  MegaNavigationView.prototype.invoke = function() {
    var offset;
    offset = Math.floor(this.navContainer.position().top + this.navTrigger.position().top + this.navTrigger.outerHeight());
    this.navTrigger.addClass('active');
    return this.nav.css('top', offset);
  };

  MegaNavigationView.prototype.dismiss = function() {
    this.navTrigger.removeClass('active');
    this.nav.css('top', '-9999px');
    return this.$el.trigger("closeMegaNav");
  };

  MegaNavigationView.prototype.closeMegaNav = function(e) {
    if ($(e.currentTarget).hasClass('has-mega-nav')) {
      if (!($(e.relatedTarget).hasClass('.mega-nav') || $(e.relatedTarget).closest('.mega-nav').length)) {
        return this.dismiss();
      }
    } else if ($(e.currentTarget).hasClass('mega-nav')) {
      if (!($(e.currentTarget).hasClass('has-mega-nav') || $(e.relatedTarget).parent().hasClass('has-mega-nav'))) {
        return this.dismiss();
      }
    }
  };

  MegaNavigationView.prototype.goDeepWithin = function(e) {
    var link, list, newHeight, origin, target, targetList;
    link = $(e.currentTarget);
    origin = link.closest('ul.mega-nav-list');
    if (link.hasClass('show-more')) {
      list = link.closest('ul.list-wrap').data('list');
      target = this.expandedList;
      targetList = target.find("li[data-list='" + list + "']");
      this.categoriesList.hide();
      this.expandedList.show().find('.list').removeClass('active');
      target.find('.back').data('target', 'main-list');
    }
    targetList.addClass('active');
    if (target.hasClass('expanded-list')) {
      target.find('.back').data('origin', 'expanded-list');
    } else {
      target.find('.back').data('origin', 'category-list');
    }
    newHeight = target.height();
    if (newHeight > origin.height()) {
      this.nav.animate({
        height: target.height()
      });
    }
    this.megaNavWrap.animate({
      top: '-=' + origin.height()
    }, (function(_this) {
      return function() {
        return target.find('.back').fadeIn(150);
      };
    })(this));
    return false;
  };

  MegaNavigationView.prototype.reset = function(e) {
    var backButton, target;
    backButton = $(e.currentTarget);
    target = backButton.parents(".mega-nav").find("." + (backButton.data('target')));
    backButton.fadeOut(150);
    this.nav.animate({
      height: target.height()
    });
    this.megaNavWrap.animate({
      top: '+=' + target.height()
    });
    if (backButton.data('origin') === 'category-list') {
      backButton.data('target', 'main-list');
      return backButton.data('origin', 'expanded-list');
    }
  };

  return MegaNavigationView;

})(Backbone.View);

IndexView = (function(superClass) {
  extend(IndexView, superClass);

  function IndexView() {
    return IndexView.__super__.constructor.apply(this, arguments);
  }

  IndexView.prototype.initialize = function() {
    setTimeout(((function(_this) {
      return function() {
        return _this.verticallyAlign();
      };
    })(this)), 500);
    WINDOW.resize((function(_this) {
      return function() {
        return _this.verticallyAlign();
      };
    })(this));
    return this.pictureBlocks = $('.picture-block');
  };

  IndexView.prototype.verticallyAlign = function() {
    var collection, j, label, labels, len, ref, results;
    ref = $('.collection');
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      collection = ref[j];
      labels = ($(collection)).find('h3, span');
      results.push((function() {
        var l, len1, results1;
        results1 = [];
        for (l = 0, len1 = labels.length; l < len1; l++) {
          label = labels[l];
          results1.push(($(label)).css({
            marginTop: ($(label)).height() / -2
          }).removeClass('preload'));
        }
        return results1;
      })());
    }
    return results;
  };

  return IndexView;

})(Backbone.View);

CollectionListView = (function(superClass) {
  extend(CollectionListView, superClass);

  function CollectionListView() {
    return CollectionListView.__super__.constructor.apply(this, arguments);
  }

  CollectionListView.prototype.initialize = function() {
    this.initializedClass = 'collection-list-initialized';
    return this._validate();
  };

  CollectionListView.prototype._validate = function() {
    setTimeout(((function(_this) {
      return function() {
        return _this.verticallyAlign();
      };
    })(this)), 500);
    return WINDOW.resize((function(_this) {
      return function() {
        return _this.verticallyAlign();
      };
    })(this));
  };

  CollectionListView.prototype.verticallyAlign = function() {
    var collection, j, label, labels, len, ref, results;
    ref = $('.collection');
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      collection = ref[j];
      labels = ($(collection)).find('h3, span');
      results.push((function() {
        var l, len1, results1;
        results1 = [];
        for (l = 0, len1 = labels.length; l < len1; l++) {
          label = labels[l];
          results1.push(($(label)).css({
            marginTop: ($(label)).height() / -2
          }).removeClass('preload'));
        }
        return results1;
      })());
    }
    return results;
  };

  return CollectionListView;

})(Backbone.View);

RTEView = (function(superClass) {
  extend(RTEView, superClass);

  function RTEView() {
    return RTEView.__super__.constructor.apply(this, arguments);
  }

  RTEView.prototype.events = {
    'click .tabs li': 'switchTabs'
  };

  RTEView.prototype.initialize = function() {
    this.rte = this.$el;
    this.setupTabs();
    this.setupImages();
    this.setupVideos();
    this.mobilifyTables();
    return WINDOW.resize((function(_this) {
      return function() {
        _this.setupVideos();
        return _this.mobilifyTables();
      };
    })(this));
  };

  RTEView.prototype.setupImages = function() {
    var images;
    images = this.rte.find('p > img');
    return images.imagesLoaded(function() {
      var image, j, len, results;
      results = [];
      for (j = 0, len = images.length; j < len; j++) {
        image = images[j];
        image = $(image);
        results.push(image.wrap('<div class="image-wrap">'));
      }
      return results;
    });
  };

  RTEView.prototype.setupVideos = function() {
    var aspectRatio, contentWidth, j, len, results, video, videos;
    videos = this.rte.not(".special").find('iframe, embed, object');
    contentWidth = this.rte.width();
    results = [];
    for (j = 0, len = videos.length; j < len; j++) {
      video = videos[j];
      video = $(video);
      aspectRatio = video.height() / video.width();
      results.push(video.css({
        width: contentWidth,
        height: contentWidth * aspectRatio
      }));
    }
    return results;
  };

  RTEView.prototype.switchTabs = function(e) {
    var aspectRatio, content, contentWidth, j, len, position, tab, tabContainer, tabContentContainer, video, videos;
    tab = $(e.currentTarget);
    tabContainer = tab.parent();
    tabContentContainer = tabContainer.next();
    position = tab.index();
    content = tabContentContainer.find('> li').eq(position);
    tabContainer.find('> li').removeClass('active');
    tabContentContainer.find('> li').removeClass('active');
    tab.addClass('active');
    content.addClass('active');
    videos = content.find('iframe, embed, object');
    contentWidth = content.width();
    for (j = 0, len = videos.length; j < len; j++) {
      video = videos[j];
      video = $(video);
      aspectRatio = video.height() / video.width();
      video.css({
        width: contentWidth,
        height: contentWidth * aspectRatio,
        visibility: 'visible'
      });
    }
    return false;
  };

  RTEView.prototype.setupTabs = function() {
    var tabs, tabsContent;
    tabs = this.rte.find('.tabs');
    tabsContent = this.rte.find('.tabs-content');
    if (this.rte.find(':first-child').hasClass('tabs')) {
      this.rte.parent().addClass('no-border');
    }
    tabs.find('li:first').addClass('active');
    return tabsContent.find('li:first').addClass('active');
  };

  RTEView.prototype.mobilifyTables = function() {
    return this.$('table').mobileTable();
  };

  return RTEView;

})(Backbone.View);

VideoView = (function(superClass) {
  extend(VideoView, superClass);

  function VideoView() {
    return VideoView.__super__.constructor.apply(this, arguments);
  }

  VideoView.prototype.initialize = function() {
    this.initializedClass = 'video-initialized';
    return this._validate();
  };

  VideoView.prototype._validate = function() {
    this.videoWrapper = this.$(".home-video-embed-wrapper", this.$el);
    this.video = this.$(".home-video-embed", this.$el);
    this.videoID = this.$(".home-video", this.$el).data("video-id");
    this.videoType = this.$(".home-video", this.$el).data("video-type");
    this.detachedVideo = null;
    if (this.videoType === "vimeo") {
      return $.getJSON("https://www.vimeo.com/api/v2/video/" + this.videoID + ".json?callback=?", {
        format: "json"
      }, function(data) {
        $(".vimeo-image", this.$el).attr("src", data[0].thumbnail_large);
      });
    }
  };

  VideoView.prototype.events = {
    "click .home-video-play-button": "openVideo",
    "keyup": "closeVideo"
  };

  VideoView.prototype.openVideo = function() {
    this.videoWrapper.addClass("opening");
    if (this.detachedVideo) {
      this.video.width("");
      this.detachedVideo.appendTo(this.video);
    } else {
      this.video.fitVids({
        customSelector: "iframe"
      });
    }
    this.verticallyCenterVideo();
    $(window).on("resize.video", (function(_this) {
      return function() {
        return _this.verticallyCenterVideo();
      };
    })(this));
    this.videoWrapper.on("click.video", (function(_this) {
      return function() {
        return _this.closeVideo();
      };
    })(this));
    return setTimeout((function(_this) {
      return function() {
        return _this.videoWrapper.addClass("open");
      };
    })(this), 20);
  };

  VideoView.prototype.centerVideoText = function() {
    var contentHeight, contentWidth, videoContent;
    videoContent = this.$(".home-video-content");
    contentWidth = videoContent.outerWidth();
    contentHeight = videoContent.outerHeight();
    return videoContent.css({
      marginTop: -(contentHeight / 2),
      marginLeft: -(contentWidth / 2)
    });
  };

  VideoView.prototype.verticallyCenterVideo = function() {
    var availableHeight, video, videoHeight, videoRatio, windowHeight;
    this.video.css({
      marginTop: 0,
      width: "100%"
    });
    video = this.video.find(".fluid-width-video-wrapper");
    videoHeight = video.outerHeight();
    videoRatio = video.width() / videoHeight;
    windowHeight = window.innerHeight || $(window).height();
    availableHeight = windowHeight - 60;
    if (videoHeight > availableHeight) {
      return this.video.removeClass("centered").css({
        marginTop: 0,
        width: availableHeight * videoRatio
      });
    } else {
      return this.video.addClass("centered").css({
        marginTop: -(videoHeight / 2),
        width: "100%"
      });
    }
  };

  VideoView.prototype.closeVideo = function(e) {
    var detach;
    if (!this.$(".home-video").length) {
      return;
    }
    if (e && this.videoWrapper.hasClass("open")) {
      if (e.which !== 27) {
        return;
      }
    }
    $(window).off("resize.video");
    this.videoWrapper.off("click.video");
    this.videoWrapper.removeClass("open");
    detach = (function(_this) {
      return function() {
        _this.detachedVideo = _this.video.find(".fluid-width-video-wrapper").detach();
        return _this.videoWrapper.removeClass("opening").off(_this.transitionend);
      };
    })(this);
    if (Modernizr.csstransitions) {
      this.videoWrapper.on(this.transitionend, (function(_this) {
        return function() {
          return detach();
        };
      })(this));
      return setTimeout((function(_this) {
        return function() {
          if (_this.videoWrapper.hasClass("opening")) {
            return detach();
          }
        };
      })(this), 300);
    } else {
      return detach();
    }
  };

  return VideoView;

})(Backbone.View);

RTEView = (function(superClass) {
  extend(RTEView, superClass);

  function RTEView() {
    return RTEView.__super__.constructor.apply(this, arguments);
  }

  RTEView.prototype.events = {
    'click .tabs li': 'switchTabs'
  };

  RTEView.prototype.initialize = function() {
    this.rte = this.$el;
    this.setupTabs();
    this.setupImages();
    this.setupVideos();
    this.mobilifyTables();
    return WINDOW.resize((function(_this) {
      return function() {
        _this.setupVideos();
        return _this.mobilifyTables();
      };
    })(this));
  };

  RTEView.prototype.setupImages = function() {
    var images;
    images = this.rte.find('p > img');
    return images.imagesLoaded(function() {
      var image, j, len, results;
      results = [];
      for (j = 0, len = images.length; j < len; j++) {
        image = images[j];
        image = $(image);
        results.push(image.wrap('<div class="image-wrap">'));
      }
      return results;
    });
  };

  RTEView.prototype.setupVideos = function() {
    var aspectRatio, contentWidth, j, len, results, video, videos;
    videos = this.rte.not(".special").find('iframe, embed, object');
    contentWidth = this.rte.width();
    results = [];
    for (j = 0, len = videos.length; j < len; j++) {
      video = videos[j];
      video = $(video);
      aspectRatio = video.height() / video.width();
      results.push(video.css({
        width: contentWidth,
        height: contentWidth * aspectRatio
      }));
    }
    return results;
  };

  RTEView.prototype.switchTabs = function(e) {
    var aspectRatio, content, contentWidth, j, len, position, tab, tabContainer, tabContentContainer, video, videos;
    tab = $(e.currentTarget);
    tabContainer = tab.parent();
    tabContentContainer = tabContainer.next();
    position = tab.index();
    content = tabContentContainer.find('> li').eq(position);
    tabContainer.find('> li').removeClass('active');
    tabContentContainer.find('> li').removeClass('active');
    tab.addClass('active');
    content.addClass('active');
    videos = content.find('iframe, embed, object');
    contentWidth = content.width();
    for (j = 0, len = videos.length; j < len; j++) {
      video = videos[j];
      video = $(video);
      aspectRatio = video.height() / video.width();
      video.css({
        width: contentWidth,
        height: contentWidth * aspectRatio,
        visibility: 'visible'
      });
    }
    return false;
  };

  RTEView.prototype.setupTabs = function() {
    var tabs, tabsContent;
    tabs = this.rte.find('.tabs');
    tabsContent = this.rte.find('.tabs-content');
    if (this.rte.find(':first-child').hasClass('tabs')) {
      this.rte.parent().addClass('no-border');
    }
    tabs.find('li:first').addClass('active');
    return tabsContent.find('li:first').addClass('active');
  };

  RTEView.prototype.mobilifyTables = function() {
    return this.$('table').mobileTable();
  };

  return RTEView;

})(Backbone.View);

ProductView = (function(superClass) {
  extend(ProductView, superClass);

  function ProductView() {
    this.setupProductDetails = bind(this.setupProductDetails, this);
    this.onScroll = bind(this.onScroll, this);
    return ProductView.__super__.constructor.apply(this, arguments);
  }

  ProductView.prototype.initialize = function(options) {
    this.data = options.data;
    this.sectionBinding();
    this.initializedClass = 'product-initialized';
    return this._validate();
  };

  ProductView.prototype._validate = function() {
    var isInitialized;
    this.window = $(window);
    this.productArea = this.$(".product-area");
    this.fullscreenViewer = this.$(".fullscreen-product-viewer");
    this.fullscreenModal = this.fullscreenViewer.find('.modal');
    this.thumbsCount = this.productArea.find('.thumb').length;
    this.productId = this.productArea.data('product-id');
    this.productZoom = this.$(".product-zoom");
    this.product = this.data.product;
    this.variants = this.product.variants;
    isInitialized = this.$el.hasClass(this.initializedClass);
    this.productImages = this.productArea.find(".product-images");
    this.productMainImage = this.$(".product-main-image");
    this.zoomArea = this.$(".product-zoom");
    this.productDetailsWrapper = this.productArea.find(".product-details-wrapper");
    this.productDetails = this.productArea.find(".product-details");
    this.$productForm = this.$("[data-product-form]");
    this.formID = this.$productForm.data('product-form');
    this.productFormId = "product_form_" + this.formID;
    this.productSelect = "#product-select-" + this.formID;
    this.$priceArea = $('.product-details .price, .mobile-product-title .price', this.productArea);
    this.$addToCartButton = $(".product-submit-wrapper input", this.productArea);
    this.$productThumbnails = $('.product-images .thumb img', this.productArea);
    this.productJSON = this.product;
    this.productSettings = this.data.productSettings;
    this.$variantDropdowns = $("[data-option-select=" + this.formID + "]", this.productArea);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;
    this.selectedThumbIndex = 0;
    this.processing = false;
    if (this.productZoom.length) {
      $.each(this.productMainImage, (function(_this) {
        return function(index, elem) {
          return $(elem).imagesLoaded(function() {
            return _this.prepareZoom($(elem), $(elem).find('.product-zoom'));
          });
        };
      })(this));
    }
    this.setupVariants();
    this.twitterSharing();
    this.googlePlusSharing();
    this.fullscreenViewer.find('.showcase .container').spin('small');
    this.transitionend = (function(transition) {
      var transEndEventNames;
      transEndEventNames = {
        "-webkit-transition": "webkitTransitionEnd",
        "-moz-transition": "transitionend",
        "-o-transition": "oTransitionEnd",
        transition: "transitionend"
      };
      return transEndEventNames[transition];
    })(Modernizr.prefixed("transition"));
    WINDOW.resize((function(_this) {
      return function() {
        return _this.resize();
      };
    })(this));
    if (this.productImages.attr('data-thumb-orientation') === 'list') {
      this.window.on("load resize", window.themeUtils.debounce(this.setupProductDetails, 100));
      return this.window.on("scroll", window.themeUtils.debounce(this.onScroll, 10));
    }
  };

  ProductView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-product')) {
          return;
        }
        _this.delegateEvents();
        return _this._validate();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-product')) {
          return;
        }
        return _this.undelegateEvents();
      };
    })(this));
  };

  ProductView.prototype.setupVariants = function() {
    var dropdownSettings, j, label, labels, len, variantHelperDefaults, width;
    variantHelperDefaults = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productMainImage: this.productMainImage,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON
    };
    if (this.$variantDropdowns.length) {
      dropdownSettings = {
        $selector: this.$variantDropdowns,
        type: 'select'
      };
      dropdownSettings = window.ThemeUtils.extend(variantHelperDefaults, dropdownSettings);
      this.variantHelpers = new VariantHelper(dropdownSettings);
      this.$variantDropdowns.trigger('change.variant-helper');
    }
    labels = this.productArea.find('.inline-field-wrapper > label');
    if (labels.length > 1) {
      width = 0;
      for (j = 0, len = labels.length; j < len; j++) {
        label = labels[j];
        if (($(label)).width() > width) {
          width = ($(label)).width();
        }
      }
      return labels.width(width);
    }
  };

  ProductView.prototype.onScroll = function() {
    if (document.documentElement.offsetWidth > 770 && document.documentElement.clientHeight > this.detailsHeight) {
      return this.positionProductInfo(this.stickyNavHeight, this.detailsWrapperOffset, this.detailsHeight);
    } else {
      return this.productDetails.css("position", "static");
    }
  };

  ProductView.prototype.events = {
    "click .product-area .thumb": "determineSelectedThumb",
    "click .fullscreen-product-viewer .thumb": "determineSelectedThumb",
    "click .toggle-fullview": "openFullview",
    "click .fullscreen-product-viewer": "closeFullview",
    "click .fullscreen-product-viewer .modal": "stopProp",
    "click .product-area .submit": "addProductToCart",
    "click .modal-wrap .close": "closeFullview",
    "change .product-area .single-option-selector": "resetErrors",
    "prepare-zoom": "prepareZoom",
    "click .product-main-image.zoom-enabled": "toggleZoom",
    "resetZoom .product-main-image": "resetZoom",
    "mouseout .product-zoom": "resetZoom",
    "mousemove .product-zoom": "zoomImage"
  };

  ProductView.prototype.resize = function() {
    this.formatTheModal();
    return this.resizeShowcase();
  };

  ProductView.prototype.stopProp = function(e) {
    return e.stopPropagation();
  };

  ProductView.prototype.setupProductDetails = function() {
    this.mainHeaderWrap = $('.main-header-wrap');
    this.productDetails.width(this.productDetailsWrapper.width());
    if (this.mainHeaderWrap.attr('data-header-format') !== 'minimal') {
      this.stickyNavHeight = 0;
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top - this.stickyNavHeight;
      this.detailsHeight = this.productDetails.outerHeight(true) + this.stickyNavHeight;
    } else {
      this.stickyNavHeight = $(".header-minimal").outerHeight(true);
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top;
      this.detailsHeight = this.productDetails.outerHeight(true);
    }
    return this.onScroll();
  };

  ProductView.prototype.positionProductInfo = function(stickyNavHeight, detailsWrapperOffset, detailsHeight) {
    var detailsBottom, detailsTop, diff, imagesBottom, makeAbsolute, makeFixed, makeStatic, productTop, scrollTop;
    scrollTop = this.window.scrollTop() + stickyNavHeight;
    detailsTop = this.productDetails.offset().top;
    detailsBottom = detailsTop + detailsHeight;
    imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);
    productTop = $('.product-area').offset().top;
    diff = scrollTop - productTop;
    if (this.productDetails.outerHeight() >= this.productImages.outerHeight(true)) {
      return;
    }
    makeStatic = (function(_this) {
      return function() {
        return _this.productDetails.css({
          "position": "static",
          "bottom": "",
          "top": ""
        });
      };
    })(this);
    makeAbsolute = (function(_this) {
      return function() {
        return _this.productDetails.css({
          "position": "absolute",
          "bottom": 0 + _this.productArea.css('padding-bottom'),
          "top": "auto"
        });
      };
    })(this);
    makeFixed = (function(_this) {
      return function() {
        return _this.productDetails.css({
          "position": "fixed",
          "top": stickyNavHeight,
          "bottom": ""
        });
      };
    })(this);
    detailsBottom = this.productDetails.offset().top + detailsHeight;
    imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);
    if (detailsWrapperOffset - scrollTop >= 0) {
      makeStatic();
      return;
    }
    if ((this.productImages.offset().top < scrollTop) && ((detailsTop - scrollTop) > 0)) {
      makeFixed();
      return;
    }
    if (!((detailsBottom + 1) >= imagesBottom && imagesBottom < (scrollTop + this.window.height()))) {
      return makeFixed();
    } else {
      return makeAbsolute();
    }
  };

  ProductView.prototype.handleErrors = function(response) {
    var error, submitButton;
    error = JSON.parse(response.responseText);
    submitButton = this.$("[data-product-form] .submit");
    this.$("[data-product-form]").append("<div class='error-message'>" + error.description + "</div>");
    return setTimeout((function(_this) {
      return function() {
        _this.processing = false;
        return submitButton.val(submitButton.data("original-text")).removeClass("disabled");
      };
    })(this), 2000);
  };

  ProductView.prototype.resetErrors = function() {
    this.$(".error-message").remove();
    return this.processing = false;
  };

  ProductView.prototype.addProductToCart = function(e) {
    var quantity, submitButton, variant;
    e.preventDefault();
    if (this.processing) {
      return;
    }
    Shopify.onError = (function(_this) {
      return function(XMLHttpRequest) {
        return _this.handleErrors(XMLHttpRequest);
      };
    })(this);
    this.resetErrors();
    submitButton = $(e.currentTarget);
    submitButton.data('original-text', submitButton.val()).val(Theme.pleaseWait).addClass('disabled');
    this.processing = true;
    variant = this.$(".product-select").val();
    quantity = this.$(".product-quantity").val();
    return Shopify.addItemFromForm(this.productFormId, (function(_this) {
      return function(product) {
        Shopify.getCart(function(cart) {
          return _this.updateMiniCart(cart);
        });
        submitButton.val(Theme.addedToCart);
        return setTimeout(function() {
          submitButton.val(submitButton.data('original-text')).removeClass('disabled');
          return _this.processing = false;
        }, 2000);
      };
    })(this));
  };

  ProductView.prototype.updateMiniCart = function(cart) {
    var i, item, itemProperties, itemText, j, len, miniCartItemsWrap, productPrice, propertiesArray, propertyKeysArray, ref, variant;
    miniCartItemsWrap = $(".mini-cart-items-wrap");
    miniCartItemsWrap.empty();
    if (cart.item_count !== 1) {
      itemText = Theme.cartItemsOther;
    } else {
      itemText = Theme.cartItemsOne;
    }
    $(".mini-cart .options").show();
    miniCartItemsWrap.find(".no-items").hide();
    $(".mini-cart-wrap label").html("<span class='item-count'>" + cart.item_count + "</span> " + itemText);
    ref = cart.items;
    for (j = 0, len = ref.length; j < len; j++) {
      item = ref[j];
      productPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
      variant = item.variant_title ? "<p class='variant'>" + item.variant_title + "</p>" : "";
      itemProperties = "";
      if (item.properties) {
        propertyKeysArray = Object.keys(item.properties);
        propertiesArray = _.values(item.properties);
        i = 0;
        while (i < propertyKeysArray.length) {
          if (propertiesArray[i].length) {
            itemProperties = itemProperties + ("<p class=\"property\">\n    <span class=\"property-label\">" + propertyKeysArray[i] + ":</span>\n    <span class=\"property-value\">" + propertiesArray[i] + "</span>\n</p>");
          }
          i++;
        }
      }
      miniCartItemsWrap.append("<div id=\"item-" + item.variant_id + "\" class=\"item clearfix\">\n    <div class=\"image-wrap\">\n        <img alt=\"" + item.title + "\" src=\"" + item.image + "\">\n        <a class=\"overlay\" href=\"" + item.url + "\"></a>\n    </div>\n    <div class=\"details\">\n        <p class=\"brand\">" + item.vendor + "</p>\n        <p class=\"title\"><a href=\"" + item.url + "\">" + item.product_title + "</a><span class=\"quantity\">× <span class=\"count\">" + item.quantity + "</span></span></p>\n        <p class=\"price\"><span class=\"money\">" + productPrice + "</span></p>\n        " + variant + "\n        " + itemProperties + "\n    </div>\n</div>");
    }
    if (Theme.currencySwitcher) {
      return $(document.body).trigger("switch-currency");
    }
  };

  ProductView.prototype.resizeShowcase = function() {
    var container, imgHeight;
    container = this.productArea.find('.container');
    imgHeight = container.find('img').height();
    if (this.productImages.attr('data-thumb-orientation') !== 'list') {
      return container.height(imgHeight);
    }
  };

  ProductView.prototype.openFullview = function(e) {
    BODY.css({
      'overflow': 'hidden'
    });
    this.fullscreenViewer.show();
    this.formatTheModal();
    if (!$('html').hasClass('lt-ie9')) {
      this.fullscreenViewer.fadeTo(300, 1, (function(_this) {
        return function() {
          _this.parent = _this.fullscreenModal;
          if (_this.thumbsCount > 0) {
            return _this.updateProductShowcase();
          }
        };
      })(this));
    } else {
      this.parent = this.fullscreenModal;
      if (this.thumbsCount > 0) {
        this.updateProductShowcase();
      }
    }
    $(document).bind('keyup', (function(_this) {
      return function(e) {
        if (e.keyCode === 27) {
          return _this.closeFullview();
        }
      };
    })(this));
    return false;
  };

  ProductView.prototype.closeFullview = function(e) {
    if ((e == null) || e.target === e.currentTarget) {
      if (!$('html').hasClass('lt-ie9')) {
        this.fullscreenViewer.fadeTo(300, 0, (function(_this) {
          return function() {
            _this.parent = _this.productArea;
            if (_this.thumbsCount > 0) {
              _this.updateProductShowcase();
            }
            _this.fullscreenViewer.hide();
            return BODY.css({
              'overflow': 'auto'
            });
          };
        })(this));
      } else {
        this.parent = this.productArea;
        if (this.thumbsCount > 0) {
          this.updateProductShowcase();
        }
        this.fullscreenViewer.hide();
        BODY.css({
          'overflow': 'auto'
        });
      }
      return $(document).unbind('keyup');
    }
  };

  ProductView.prototype.formatTheModal = function() {
    var container, imgHeight;
    container = this.fullscreenModal.find('.container');
    imgHeight = container.find('img').height();
    container.height(imgHeight);
    this.scroller = this.fullscreenViewer.find('.pager').antiscroll({
      autoHide: false
    }).data('antiscroll');
    this.fullscreenViewer.find('.pager').height(imgHeight).one(this.transitionend, (function(_this) {
      return function(e) {
        return _this.scroller.refresh();
      };
    })(this));
    return container.imagesLoaded((function(_this) {
      return function() {
        return _this.verticallyAlignModal();
      };
    })(this));
  };

  ProductView.prototype.verticallyAlignModal = function(imageHeight) {
    var modalHeight, offset, windowHeight;
    windowHeight = WINDOW.height();
    if (imageHeight) {
      modalHeight = imageHeight + 118;
    } else {
      modalHeight = this.fullscreenModal.outerHeight();
    }
    if (windowHeight <= modalHeight) {
      return this.fullscreenModal.css({
        'margin-top': 0
      });
    } else {
      offset = (windowHeight - modalHeight) / 2;
      this.fullscreenModal.css({
        'margin-top': offset
      });
      return window.setTimeout(function() {
        return $('.fullscreen-product-viewer .modal').addClass('transitions-are-go');
      }, 50);
    }
  };

  ProductView.prototype.determineSelectedThumb = function(e) {
    this.selectedThumbIndex = ($(e.currentTarget)).index();
    if (this.fullscreenViewer.is(":visible")) {
      this.parent = this.$('.modal-wrap');
    } else {
      this.parent = this.productArea;
    }
    return this.updateProductShowcase();
  };

  ProductView.prototype.updateProductShowcase = function() {
    var activeThumb, animationSpeed, img, selectedImg, selectedThumb, showcaseContainer, showcaseImage, showcaseWrap, src;
    showcaseContainer = this.parent.find('.showcase .container');
    showcaseWrap = showcaseContainer.find('.wrap');
    showcaseImage = showcaseContainer.find('img');
    showcaseContainer.height(showcaseImage.height());
    activeThumb = this.parent.find('.thumb.active');
    selectedThumb = this.parent.find('.thumb').eq(this.selectedThumbIndex);
    selectedImg = selectedThumb.find('img');
    src = selectedImg.data('high-res-url');
    if (this.selectedThumbIndex !== activeThumb.index()) {
      img = new Image();
      img.src = src;
      img = $(img);
      animationSpeed = 200;
      return showcaseWrap.fadeTo(animationSpeed, 0, (function(_this) {
        return function() {
          showcaseImage.remove();
          _this.resetZoom();
          return img.imagesLoaded(function() {
            showcaseWrap.append(img);
            _this.prepareZoom(_this.productMainImage, _this.zoomArea);
            showcaseContainer.animate({
              height: img.height()
            }, animationSpeed, 'linear', function() {
              activeThumb.removeClass('active');
              selectedThumb.addClass('active');
              return showcaseWrap.fadeTo(animationSpeed, 1);
            });
            if (_this.fullscreenViewer.is(":visible")) {
              _this.verticallyAlignModal(img.height());
              return _this.fullscreenViewer.find('.pager').height(img.height()).one(_this.transitionend, function(e) {
                return _this.scroller.refresh();
              });
            }
          });
        };
      })(this));
    }
  };

  ProductView.prototype.prepareZoom = function($productImage, $productZoomArea) {
    var newZoomImage, photoAreaHeight, photoAreaWidth;
    if (!$productZoomArea.length) {
      return;
    }
    photoAreaWidth = $productImage.width();
    photoAreaHeight = $productImage.height();
    newZoomImage = new Image();
    $(newZoomImage).on("load", (function(_this) {
      return function() {
        var ratio, ratios;
        _this.zoomImageWidth = newZoomImage.width;
        _this.zoomImageHeight = newZoomImage.height;
        ratios = new Array();
        ratios[0] = _this.zoomImageWidth / photoAreaWidth;
        ratios[1] = _this.zoomImageHeight / photoAreaHeight;
        ratio = Math.max.apply(Math, ratios);
        if (ratio < 1.4) {
          $productImage.removeClass("zoom-enabled");
        } else {
          $productImage.addClass("zoom-enabled");
          return $productZoomArea.css({
            backgroundImage: "url(" + newZoomImage.src + ")"
          });
        }
      };
    })(this));
    return newZoomImage.src = $productImage.find('img').attr('src');
  };

  ProductView.prototype.resetZoom = function() {
    return this.zoomArea.removeClass("active").css('background-position', '');
  };

  ProductView.prototype.toggleZoom = function(e) {
    if (this.productMainImage.hasClass("zoom-enabled")) {
      if (e.type === "mouseout") {
        this.zoomArea.removeClass("active");
        this.resetZoom();
        return;
      }
      ($(e.currentTarget)).find('.product-zoom').toggleClass("active");
      return this.zoomImage(e);
    }
  };

  ProductView.prototype.zoomImage = function(e) {
    var $productImage, $productZoomArea, bigImageOffset, bigImageX, bigImageY, mousePositionX, mousePositionY, newBackgroundPosition, ratioX, ratioY, theImage, zoomHeight, zoomWidth;
    if (($(e.currentTarget)).hasClass("product-main-image")) {
      $productImage = $(e.currentTarget);
      $productZoomArea = $productImage.find('.product-zoom');
    } else {
      $productZoomArea = $(e.currentTarget);
      $productImage = $productZoomArea.parent('.product-main-image');
    }
    zoomWidth = $productZoomArea.width();
    zoomHeight = $productZoomArea.height();
    bigImageOffset = $productImage.offset();
    bigImageX = Math.round(bigImageOffset.left);
    bigImageY = Math.round(bigImageOffset.top);
    mousePositionX = e.pageX - bigImageX;
    mousePositionY = e.pageY - bigImageY;
    if (mousePositionX < zoomWidth && mousePositionY < zoomHeight && mousePositionX > 0 && mousePositionY > 0) {
      if ($productZoomArea.hasClass("active")) {
        theImage = new Image();
        theImage.src = $productImage.find('img').attr("src");
        this.zoomImageWidth = theImage.width;
        this.zoomImageHeight = theImage.height;
        ratioX = Math.round(mousePositionX / zoomWidth * this.zoomImageWidth - zoomWidth / 2) * -1;
        ratioY = Math.round(mousePositionY / zoomHeight * this.zoomImageHeight - zoomHeight / 2) * -1;
        if (ratioX > 0) {
          ratioX = 0;
        }
        if (ratioY > 0) {
          ratioY = 0;
        }
        if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
          ratioX = -(this.zoomImageWidth - zoomWidth);
        }
        if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
          ratioY = -(this.zoomImageHeight - zoomHeight);
        }
        newBackgroundPosition = ratioX + "px " + ratioY + "px";
        return $productZoomArea.css({
          backgroundPosition: newBackgroundPosition
        });
      }
    }
  };

  ProductView.prototype.twitterSharing = function() {
    return !(function(d, s, id) {
      var js, p, ref, twitterjs;
      js = void 0;
      twitterjs = d.getElementsByTagName(s)[0];
      p = /^http:/.test(d.location) ? 'http' : 'https';
      if (!d.getElementById(id)) {
        js = d.createElement(s);
        js.id = id;
        js.src = p + '://platform.twitter.com/widgets.js';
        twitterjs.parentNode.insertBefore(js, twitterjs);
      } else {
        if (typeof twttr !== "undefined" && twttr !== null) {
          if ((ref = twttr.widgets) != null) {
            if (typeof ref.load === "function") {
              ref.load();
            }
          }
        }
      }
    })(document, 'script', 'twitter-wjs');
  };

  ProductView.prototype.googlePlusSharing = function() {
    return !(function(d, s, id) {
      var googlejs, js;
      js = void 0;
      googlejs = d.getElementsByTagName(s)[0];
      if (!d.getElementById(id)) {
        js = d.createElement(s);
        js.type = 'text/javascript';
        js.async = true;
        js.src = 'https://apis.google.com/js/plusone.js';
        googlejs.parentNode.insertBefore(js, googlejs);
      }
    })(document, 'script', 'google-wjs');
  };

  ProductView.prototype.update = function($el) {
    this.$el = $el;
    return this._validate();
  };

  return ProductView;

})(Backbone.View);

SharingWidgetView = (function(superClass) {
  extend(SharingWidgetView, superClass);

  function SharingWidgetView() {
    return SharingWidgetView.__super__.constructor.apply(this, arguments);
  }

  SharingWidgetView.prototype.initialize = function() {
    this.sectionBinding();
    return this.validate();
  };

  SharingWidgetView.prototype.validate = function() {
    this.twitterSharing();
    return this.googlePlusSharing();
  };

  SharingWidgetView.prototype.twitterSharing = function() {
    return !(function(d, s, id) {
      var js, p, twitterjs;
      js = void 0;
      twitterjs = d.getElementsByTagName(s)[0];
      p = /^http:/.test(d.location) ? 'http' : 'https';
      if (!d.getElementById(id)) {
        js = d.createElement(s);
        js.id = id;
        js.src = p + '://platform.twitter.com/widgets.js';
        twitterjs.parentNode.insertBefore(js, twitterjs);
      } else {
        twttr.widgets.load();
      }
    })(document, 'script', 'twitter-wjs');
  };

  SharingWidgetView.prototype.googlePlusSharing = function() {
    return !(function(d, s, id) {
      var googlejs, js;
      js = void 0;
      googlejs = d.getElementsByTagName(s)[0];
      if (!d.getElementById(id)) {
        js = d.createElement(s);
        js.type = 'text/javascript';
        js.async = true;
        js.src = 'https://apis.google.com/js/plusone.js';
        googlejs.parentNode.insertBefore(js, googlejs);
      }
    })(document, 'script', 'google-wjs');
  };

  SharingWidgetView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-article')) {
          return;
        }
        _this.delegateEvents();
        return _this.validate();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-article')) {
          return;
        }
        return _this.undelegateEvents();
      };
    })(this));
  };

  return SharingWidgetView;

})(Backbone.View);

CartView = (function(superClass) {
  extend(CartView, superClass);

  function CartView() {
    return CartView.__super__.constructor.apply(this, arguments);
  }

  CartView.prototype.events = {
    'change .quantity .field': 'updateQuantity',
    'change .instructions textarea': 'saveNote',
    'click .get-rates': 'calculateShipping',
    'keydown #address_zip': 'calculateShipping'
  };

  CartView.prototype.initialize = function() {
    this.sectionBinding();
    return this.render();
  };

  CartView.prototype.render = function() {
    var error;
    this.cartForm = this.$("#cart-form");
    this.$shippingStrings = this.$('[data-shipping-calculator-strings]');
    this.shippingContext = {};
    if (this.$shippingStrings.length) {
      try {
        this.shippingContext = JSON.parse(this.$shippingStrings.text());
      } catch (error1) {
        error = error1;
        console.log('No shipping localisations found, unable to continue.');
      }
      if (this.shippingContext == null) {
        return;
      }
      if (this.$('[data-cart-item]').length) {
        this.shippingCalculator();
      }
    }
    return Shopify.onError = (function(_this) {
      return function(XMLHttpRequest) {
        return _this.handleErrors(XMLHttpRequest);
      };
    })(this);
  };

  CartView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-cart')) {
          return;
        }
        _this.delegateEvents();
        return _this.render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-cart')) {
          return;
        }
        return _this.undelegateEvents();
      };
    })(this));
  };

  CartView.prototype.updateQuantity = function(e) {
    var id, input, quantity, url;
    input = $(e.currentTarget);
    quantity = input.val();
    id = input.data('id');
    url = "/cart/change/" + id + "?quantity=" + quantity;
    return window.location = url;
  };

  CartView.prototype.saveNote = function() {
    var newNote;
    newNote = $('.instructions textarea').val();
    return Shopify.updateCartNote(newNote, function(cart) {});
  };

  CartView.prototype.shippingCalculator = function() {
    return Shopify.Cart.ShippingCalculator.show({
      submitButton: this.shippingContext.submitButton,
      submitButtonDisabled: this.shippingContext.submitButtonDisabled,
      customerIsLoggedIn: this.shippingContext.customerIsLoggedIn,
      moneyFormat: this.shippingContext.moneyFormat
    });
  };

  CartView.prototype.calculateShipping = function(e) {
    var shippingAddress;
    if (e && e.type === 'keydown') {
      if (e.keyCode === 13) {
        e.preventDefault();
        $('.wrapper-response').empty();
      } else {
        return;
      }
    }
    shippingAddress = {};
    shippingAddress.zip = $('.address-zip').val() || '';
    shippingAddress.country = $('.address-country').val() || '';
    shippingAddress.province = $('.address-province').val() || '';
    return Shopify.getCartShippingRatesForDestination(shippingAddress, (function(_this) {
      return function() {
        var address, firstRate, j, len, multipleShippingRates, oneShippingRate, price, rate, rateValues, ratesFeedback, results;
        address = shippingAddress.zip + ", " + shippingAddress.province + ", " + shippingAddress.country;
        if (!shippingAddress.province.length) {
          address = shippingAddress.zip + ", " + shippingAddress.country;
        }
        if (!shippingAddress.zip.length) {
          address = shippingAddress.province + ", " + shippingAddress.country;
        }
        if (!(shippingAddress.province.length && shippingAddress.zip.length)) {
          address = shippingAddress.country;
        }
        $('.wrapper-response').empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
        ratesFeedback = $('.shipping-calculator-response');
        if (rates.length > 1) {
          firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
          multipleShippingRates = Theme.shippingCalcMultiRates.replace('--address--', address).replace('--number_of_rates--', rates.length).replace('--rate--', "<span class='money'>" + firstRate + "</span>");
          ratesFeedback.html(multipleShippingRates);
        } else if (rates.length === 1) {
          oneShippingRate = Theme.shippingCalcOneRate.replace('--address--', address);
          ratesFeedback.html(oneShippingRate);
        } else {
          ratesFeedback.html(Theme.shippingCalcNoRates);
        }
        results = [];
        for (j = 0, len = rates.length; j < len; j++) {
          rate = rates[j];
          price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
          rateValues = Theme.shippingCalcRateValues.replace('--rate_title--', rate.name).replace('--rate--', "<span class='money'>" + price + "</span>");
          results.push($('.shipping-rates').append("<li>" + rateValues + "</li>"));
        }
        return results;
      };
    })(this));
  };

  CartView.prototype.handleErrors = function(errors) {
    var errorMessage;
    console.log(errors);
    errorMessage = $.parseJSON(errors.responseText);
    errorMessage = Theme.shippingCalcErrorMessage.replace('--error_message--', errorMessage.zip);
    return $('.wrapper-response').html("<p class='message'>" + errorMessage + "</p>");
  };

  return CartView;

})(Backbone.View);

ListCollectionsView = (function(superClass) {
  extend(ListCollectionsView, superClass);

  function ListCollectionsView() {
    return ListCollectionsView.__super__.constructor.apply(this, arguments);
  }

  ListCollectionsView.prototype.initialize = function() {
    setTimeout(((function(_this) {
      return function() {
        return _this.verticallyAlign();
      };
    })(this)), 500);
    return WINDOW.resize((function(_this) {
      return function() {
        return _this.verticallyAlign();
      };
    })(this));
  };

  ListCollectionsView.prototype.verticallyAlign = function() {
    var collection, j, label, labels, len, ref, results;
    ref = $('.collection');
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      collection = ref[j];
      labels = ($(collection)).find('h2');
      results.push((function() {
        var l, len1, results1;
        results1 = [];
        for (l = 0, len1 = labels.length; l < len1; l++) {
          label = labels[l];
          results1.push(($(label)).css({
            marginTop: ($(label)).height() / -2
          }).removeClass('preload'));
        }
        return results1;
      })());
    }
    return results;
  };

  return ListCollectionsView;

})(Backbone.View);

CollectionView = (function(superClass) {
  extend(CollectionView, superClass);

  function CollectionView() {
    return CollectionView.__super__.constructor.apply(this, arguments);
  }

  CollectionView.prototype.el = $('.template-collection');

  CollectionView.prototype.events = {
    'change #sort-by': 'sortDropDown'
  };

  CollectionView.prototype.initialize = function() {
    this.titleContainer = $('.page-title');
    this.title = this.titleContainer.find('.label');
    this.tagsWrap = $('.tags-wrap');
    this.tags = this.tagsWrap.find('.tags');
    this.tagsWrap.removeClass('preload');
    this.tagFilters();
    return this.setSortDropdown();
  };

  CollectionView.prototype.setSortDropdown = function() {
    var urlParam;
    urlParam = new RegExp('[\?&]' + 'sort_by' + '=([^&#]*)').exec(window.location.href);
    if (urlParam && urlParam[1]) {
      return $('#sort-by').val(urlParam[1]);
    }
  };

  CollectionView.prototype.sortDropDown = function(e) {
    var aCouples, aKeyValue, i;
    Shopify.queryParams = {};
    if (location.search.length) {
      aKeyValue = void 0;
      i = 0;
      aCouples = location.search.substr(1).split('&');
      while (i < aCouples.length) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
        i++;
      }
    }
    Shopify.queryParams.sort_by = $(e.currentTarget).val();
    return location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
  };

  CollectionView.prototype.tagFilters = function() {
    var collFilters;
    collFilters = $('.coll-filter');
    return collFilters.change(function() {
      var dataUrl, newTags, query;
      newTags = [];
      dataUrl = ($(this)).data('window-href');
      collFilters.each(function() {
        if (($(this)).val()) {
          return newTags.push(($(this)).val());
        }
      });
      if (newTags.length) {
        query = newTags.join('+');
        return window.location.href = dataUrl + '/' + query;
      } else {
        return window.location.href = dataUrl;
      }
    });
  };

  return CollectionView;

})(Backbone.View);

QuickShopView = (function(superClass) {
  extend(QuickShopView, superClass);

  function QuickShopView() {
    return QuickShopView.__super__.constructor.apply(this, arguments);
  }

  QuickShopView.prototype.el = $('.quick-shop');

  QuickShopView.prototype.events = {
    'click': 'close',
    'click .close-modal': 'close',
    'click .quick-shop-modal .thumb': 'updateQuickShopShowcase',
    'click .quick-shop-modal .submit:not(.disabled)': 'addToCart'
  };

  QuickShopView.prototype.initialize = function() {
    this.quickShop = $('.quick-shop');
    this.quickShopModal = this.quickShop.find('.quick-shop-modal');
    this.errorWrap = $('.error-wrap');
    $('.product-inner [data-quickshop-id]').click((function(_this) {
      return function(e) {
        return _this.open(e);
      };
    })(this));
    this.verticallyAlignTriggers();
    return WINDOW.resize((function(_this) {
      return function() {
        _this.formatTheModal();
        _this.setupVideos();
        return _this.verticallyAlignTriggers();
      };
    })(this));
  };

  QuickShopView.prototype.verticallyAlignTriggers = function() {
    var j, label, len, ref, results;
    ref = $('.product-inner .label');
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      label = ref[j];
      results.push(($(label)).css({
        marginTop: ($(label)).height() / -2
      }));
    }
    return results;
  };

  QuickShopView.prototype.formatTheModal = function() {
    var container, imgHeight, offset;
    container = this.quickShopModal.find('.container');
    imgHeight = container.find('img').height();
    container.height(imgHeight);
    if (WINDOW.height() <= $('.quick-shop-modal').outerHeight()) {
      return this.quickShopModal.css({
        'margin-top': 0
      });
    } else {
      offset = (WINDOW.height() - $('.quick-shop-modal').outerHeight()) / 2;
      return this.quickShopModal.css({
        'margin-top': offset
      });
    }
  };

  QuickShopView.prototype.setupVideos = function() {
    var aspectRatio, contentWidth, j, len, results, video, videos;
    videos = this.quickShopModal.find('.rte iframe:visible, .rte embed:visible, .rte object:visible');
    contentWidth = this.quickShopModal.find('.rte').width();
    results = [];
    for (j = 0, len = videos.length; j < len; j++) {
      video = videos[j];
      video = $(video);
      aspectRatio = video.height() / video.width();
      results.push(video.css({
        width: contentWidth,
        height: contentWidth * aspectRatio,
        visibility: 'visible'
      }));
    }
    return results;
  };

  QuickShopView.prototype.open = function(e) {
    var quickShopContent, ref;
    e.preventDefault();
    this.itemId = ($(e.currentTarget)).data('quickshop-id');
    this.item = Theme.products[this.itemId];
    quickShopContent = $("#quick-shop-" + this.itemId);
    BODY.css({
      'overflow': 'hidden'
    });
    this.quickShop.show();
    this.quickShopModal.append(quickShopContent);
    this.setupVariants(quickShopContent);
    this.formatTheModal();
    this.setupVideos();
    if (!$('html').hasClass('lt-ie9')) {
      this.quickShop.fadeTo(200, 1);
    }
    this.quickShop.find('.showcase .container').spin('small');
    if (typeof Shopify !== "undefined" && Shopify !== null) {
      if ((ref = Shopify.PaymentButton) != null) {
        if (typeof ref.init === "function") {
          ref.init();
        }
      }
    }
    return $(document).bind('keyup', (function(_this) {
      return function(e) {
        if (e.keyCode === 27) {
          return _this.close();
        }
      };
    })(this));
  };

  QuickShopView.prototype.setupVariants = function(quickShopContent) {
    var $productJSON, $productSettings, dropdownSettings, j, label, labels, len, variantHelperDefaults, width;
    this.$quickshopForm = $(".quick-shop-form", quickShopContent);
    this.quickshopformID = parseInt(this.$quickshopForm.attr('data-quickshop-form'), 10);
    this.productSelect = "#product-select-" + this.quickshopformID;
    this.$priceArea = $('.product-details-wrapper .price', quickShopContent);
    this.$addToCartButton = $(".selector-wrapper .submit", quickShopContent);
    this.$productThumbnails = $('.showcase .thumb img', quickShopContent);
    $productJSON = $("[data-quickshop-json-" + this.quickshopformID + "]", quickShopContent);
    $productSettings = $("[data-quickshop-settings-" + this.quickshopformID + "]", quickShopContent);
    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    this.$variantDropdowns = $("[data-option-select=" + this.quickshopformID + "]", quickShopContent);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;
    variantHelperDefaults = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$quickshopForm,
      $productThumbnails: this.$productThumbnails,
      formID: this.quickshopformID,
      productSettings: this.productSettings,
      productJSON: this.productJSON
    };
    if (this.$variantDropdowns.length) {
      dropdownSettings = {
        $selector: this.$variantDropdowns,
        type: 'select'
      };
      dropdownSettings = window.ThemeUtils.extend(variantHelperDefaults, dropdownSettings);
      this.variantHelpers = new VariantHelper(dropdownSettings);
    }
    labels = quickShopContent.find('.inline-field-wrapper > label');
    if (labels.length > 1) {
      width = 0;
      for (j = 0, len = labels.length; j < len; j++) {
        label = labels[j];
        if (($(label)).width() > width) {
          width = ($(label)).width();
        }
      }
      return labels.width(width);
    }
  };

  QuickShopView.prototype.close = function(e) {
    var id, quantity, quickShopContent, ref, submit;
    if ((e == null) || e.target === e.currentTarget) {
      submit = this.quickShopModal.find('.submit');
      quantity = this.quickShopModal.find('.product-quantity');
      quickShopContent = this.quickShopModal.find('.quick-shop-content');
      id = quickShopContent.attr('id').split('-')[2];
      $('.product-' + id).append(quickShopContent);
      if ($('html').hasClass('lt-ie9')) {
        this.quickShop.hide();
        this.quickShopModal.html('');
        BODY.css({
          'overflow': 'auto'
        });
        quantity.val('1');
      } else {
        this.quickShop.fadeTo(200, 0, (function(_this) {
          return function() {
            _this.quickShop.hide();
            _this.quickShopModal.html('');
            BODY.css({
              'overflow': 'auto'
            });
            return quantity.val('1');
          };
        })(this));
      }
      this.errorWrap.html('');
      $(document).unbind('keyup');
      return (ref = this.variantHelpers) != null ? ref.unload() : void 0;
    }
  };

  QuickShopView.prototype.updateQuickShopShowcase = function(e) {
    var activeThumb, img, selectedImg, selectedThumb, showcaseContainer, showcaseImage, showcaseWrap, src;
    showcaseContainer = this.quickShop.find('.showcase .container');
    showcaseWrap = showcaseContainer.find('.wrap');
    showcaseImage = showcaseContainer.find('img');
    showcaseContainer.height(showcaseImage.height());
    activeThumb = this.quickShop.find('.pager .thumb.active');
    selectedThumb = $(e.currentTarget);
    selectedImg = selectedThumb.find('img');
    src = selectedImg.data('high-res-url');
    img = new Image();
    img.src = src;
    img = $(img);
    img.removeAttr('height width');
    return showcaseWrap.fadeTo(200, 0, (function(_this) {
      return function() {
        showcaseImage.remove();
        return img.imagesLoaded(function() {
          showcaseWrap.append(img);
          return showcaseContainer.animate({
            height: img.height()
          }, function() {
            activeThumb.removeClass('active');
            selectedThumb.addClass('active');
            return showcaseWrap.fadeTo(200, 1);
          });
        });
      };
    })(this));
  };

  QuickShopView.prototype.updateMiniCart = function(cart, properties) {
    var i, item, itemProperties, itemText, j, len, miniCartItemsWrap, productPrice, propertiesArray, propertyKeysArray, ref, variant;
    miniCartItemsWrap = $(".mini-cart-items-wrap");
    miniCartItemsWrap.empty();
    if (cart.item_count !== 1) {
      itemText = Theme.cartItemsOther;
    } else {
      itemText = Theme.cartItemsOne;
    }
    if (cart.item_count > 0) {
      $(".mini-cart .options").show();
      miniCartItemsWrap.find(".no-items").hide();
    }
    $(".mini-cart-wrap label").html("<span class='item-count'>" + cart.item_count + "</span> " + itemText);
    ref = cart.items;
    for (j = 0, len = ref.length; j < len; j++) {
      item = ref[j];
      productPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
      variant = item.variant_title ? "<p class='variant'>" + item.variant_title + "</p>" : "";
      itemProperties = "";
      if (item.properties) {
        propertyKeysArray = Object.keys(item.properties);
        propertiesArray = _.values(item.properties);
        i = 0;
        while (i < propertyKeysArray.length) {
          if (propertiesArray[i].length) {
            itemProperties = itemProperties + ("<p class=\"property\">\n    <span class=\"property-label\">" + propertyKeysArray[i] + ":</span>\n    <span class=\"property-value\">" + propertiesArray[i] + "</span>\n</p>");
          }
          i++;
        }
      }
      miniCartItemsWrap.append("<div id=\"item-" + item.variant_id + "\" class=\"item clearfix\">\n    <div class=\"image-wrap\">\n        <img alt=\"" + item.title + "\" src=\"" + item.image + "\">\n        <a class=\"overlay\" href=\"" + item.url + "\"></a>\n    </div>\n    <div class=\"details\">\n        <p class=\"brand\">" + item.vendor + "</p>\n        <p class=\"title\"><a href=\"" + item.url + "\">" + item.product_title + "</a><span class=\"quantity\">× <span class=\"count\">" + item.quantity + "</span></span></p>\n        <p class=\"price\"><span class=\"money\">" + productPrice + "</span></p>\n        " + variant + "\n        " + itemProperties + "\n    </div>\n</div>");
    }
    if (Theme.currencySwitcher) {
      return $(document.body).trigger("switch-currency");
    }
  };

  QuickShopView.prototype.addToCart = function(e) {
    var button, imageAlt, j, l, len, len1, postToCartUrl, productFormId, productId, properties, ref, selector, thumb, variantSelectors, variantTitle;
    e.preventDefault();
    Shopify.onError = (function(_this) {
      return function(XMLHttpRequest) {
        return _this.handleErrors(XMLHttpRequest);
      };
    })(this);
    variantTitle = '';
    variantSelectors = this.quickShop.find('.single-option-selector');
    for (j = 0, len = variantSelectors.length; j < len; j++) {
      selector = variantSelectors[j];
      selector = $(selector);
      variantTitle += selector.val() + " / ";
    }
    variantTitle = variantTitle.substring(0, variantTitle.length - 3);
    properties = {};
    properties.variant = {};
    properties.product = {};
    properties.quantity = {};
    properties.matching_image = {};
    properties.quantity.added = this.quickShop.find('.product-quantity').val();
    properties.variant.id = this.quickShop.find('.product-select').val();
    properties.variant.title = this.quickShop.find('.product-select').data('variant-title') || variantTitle;
    properties.product.title = this.quickShop.find('.title').text();
    properties.product.url = this.quickShop.find('.title a').attr('href');
    ref = this.quickShop.find('.thumb');
    for (l = 0, len1 = ref.length; l < len1; l++) {
      thumb = ref[l];
      imageAlt = $(thumb).find('img').attr('alt');
      if (variantTitle.indexOf(imageAlt) > -1) {
        properties.matching_image = $(thumb).find('img').attr('src');
      }
    }
    postToCartUrl = "/cart/add.js?quantity=" + properties.quantity.added + "&id=" + properties.variant.id;
    productId = this.quickShop.find('[data-product-id]').data('product-id');
    productFormId = "product_form_" + productId;
    button = this.quickShop.find('.submit');
    button.data('original-text', button.val());
    button.val(Theme.pleaseWait).addClass('disabled');
    return Shopify.addItemFromForm(productFormId, (function(_this) {
      return function(product) {
        button.val(Theme.addedToCart);
        setTimeout(function() {
          return button.val(_this.productSettings.addToCartText).removeClass('disabled');
        }, 2000);
        _this.errorWrap.html('');
        return Shopify.getCart(function(cart) {
          return _this.updateMiniCart(cart, properties);
        });
      };
    })(this));
  };

  QuickShopView.prototype.handleErrors = function(error) {
    var button, errorMsg;
    button = this.quickShop.find('.submit');
    button.val(button.data('original-text')).removeClass('disabled');
    error = $.parseJSON(error.responseText);
    errorMsg = "<p>" + error.description + "</p>";
    return this.errorWrap.html(errorMsg);
  };

  return QuickShopView;

})(Backbone.View);

AccountView = (function(superClass) {
  extend(AccountView, superClass);

  function AccountView() {
    return AccountView.__super__.constructor.apply(this, arguments);
  }

  AccountView.prototype.events = function() {
    return {
      'click .guest-login a': 'submitGuestCheckout'
    };
  };

  AccountView.prototype.submitGuestCheckout = function() {
    $('#customer_login_guest').submit();
    return false;
  };

  return AccountView;

})(Backbone.View);

SlideshowView = (function(superClass) {
  extend(SlideshowView, superClass);

  function SlideshowView() {
    return SlideshowView.__super__.constructor.apply(this, arguments);
  }

  SlideshowView.prototype.initialize = function() {
    this.initializedClass = 'slideshow-initialized';
    return this._validate();
  };

  SlideshowView.prototype._validate = function() {
    var _slide, fn, i, isInitialized, j, len, ref;
    this.slides = this.$('.slide', this.$el);
    this.slideshow = $('.slideshow', this.$el);
    this.jumpLinksWrap = $('.jump-to-slide', this.$el);
    this.fadeSpeed = 400;
    this.autoPlay = parseInt($('.slideshow', this.$el).attr('data-autoplay'), 10);
    isInitialized = this.$el.hasClass(this.initializedClass);
    this.slides.first().addClass('first');
    this.slides.last().addClass('last');
    this.jumpLinksWrap.html('');
    ref = this.slides;
    fn = (function(_this) {
      return function() {
        var slide;
        slide = _slide;
        if (_this.slides.length > 0) {
          _this.jumpLinksWrap.append($('<li>'));
        }
        if (i === 0) {
          slide = $(slide);
          return slide.imagesLoaded(function() {
            return slide.fadeTo('200', 1, function() {
              var height;
              height = slide.height();
              slide.css('z-index', 2000).addClass('active');
              return slide.parent().css('height', height);
            });
          });
        }
      };
    })(this);
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      _slide = ref[i];
      fn();
    }
    this.jumpLinks = this.jumpLinksWrap.find('li');
    this.jumpLinksWrap.find('li:first').addClass('active');
    if (this.slideshow.attr('data-full-width') === 'true') {
      this.slideshow.parents('.shopify-section').next('.shopify-section').addClass('slideshow-sibling-section');
    }
    if (this.slides.length === 1) {
      this.$('.next, .prev, .jump-to-slide').remove();
    }
    if (this.autoPlay > 1) {
      this.autoPlaySlides();
    }
    return WINDOW.resize((function(_this) {
      return function() {
        return $('.slideshow', _this.$el).css({
          height: _this.slides.filter('.active').height()
        });
      };
    })(this));
  };

  SlideshowView.prototype.events = {
    'click .next': 'nextSlide',
    'click .prev': 'previousSlide',
    'click .jump-to-slide li:not(.active)': 'jumpToSlide'
  };

  SlideshowView.prototype.selectedHeight = function(event) {
    return $(event.target).imagesLoaded((function(_this) {
      return function() {
        return setTimeout((function() {
          $('.slide', _this.$el).removeClass('active');
          $(event.target).addClass('active');
          return $('.slideshow', _this.$el).css({
            height: $(event.target).height()
          });
        }), 1000);
      };
    })(this));
  };

  SlideshowView.prototype.autoPlaySlides = function() {
    var interval;
    if (!!$('.slideshow', this.$el).hasClass('autoplay-enabled')) {
      return;
    }
    if (this.slides.length > 1) {
      $('.slideshow', this.$el).addClass('autoplay-enabled');
      return interval = setInterval(((function(_this) {
        return function() {
          if (!$('.slideshow', _this.$el).hasClass('paused')) {
            _this.nextSlide();
          }
        };
      })(this)), this.autoPlay);
    }
  };

  SlideshowView.prototype.slideStatus = function() {
    return $('.slideshow', this.$el).toggleClass('paused');
  };

  SlideshowView.prototype.lockSlide = function(event) {
    this.slidesLocked = true;
    $(event.target).closest('.slideshow', this.$el).addClass('paused');
    this.jumpToSlide(event);
    return this.selectedHeight(event);
  };

  SlideshowView.prototype.unlockSlide = function() {
    this.slidesLocked = false;
    return $(event.target).closest('.slideshow', this.$el).removeClass('paused');
  };

  SlideshowView.prototype.nextSlide = function() {
    var isLast, upcomingSlide;
    isLast = this.$('.slide.active').hasClass('last');
    upcomingSlide = isLast ? this.slides.first() : this.$('.slide.active').next();
    return this.switchToSlide(upcomingSlide);
  };

  SlideshowView.prototype.previousSlide = function() {
    var isFirst, upcomingSlide;
    isFirst = this.$('.slide.active').hasClass('first');
    upcomingSlide = isFirst ? this.slides.last() : this.$('.slide.active').prev();
    return this.switchToSlide(upcomingSlide);
  };

  SlideshowView.prototype.jumpToSlide = function(event) {
    var jumpPosition, upcomingSlide;
    jumpPosition = ($(event.target)).index();
    upcomingSlide = this.slides.eq(jumpPosition);
    return this.switchToSlide(upcomingSlide);
  };

  SlideshowView.prototype.switchToSlide = function(upcomingSlide) {
    var currentJumpLink, currentSlide, j, jumpLinks, jumpLinksWrap, len, ref, upcomingJumpLink, upcomingSlidePosition;
    currentSlide = this.$('.slide.active');
    upcomingSlidePosition = upcomingSlide.index();
    ref = this.jumpLinksWrap;
    for (j = 0, len = ref.length; j < len; j++) {
      jumpLinksWrap = ref[j];
      jumpLinksWrap = $(jumpLinksWrap);
      jumpLinks = jumpLinksWrap.find('li');
      upcomingJumpLink = jumpLinks.eq(upcomingSlidePosition);
      currentJumpLink = jumpLinks.filter('.active');
      currentJumpLink.removeClass('active');
      upcomingJumpLink.addClass('active');
    }
    $('.slideshow', this.$el).css({
      'height': upcomingSlide.height()
    });
    currentSlide.fadeTo(this.fadeSpeed, 0, function() {
      return currentSlide.removeClass('active');
    });
    return upcomingSlide.fadeTo(this.fadeSpeed, 1, function() {
      return upcomingSlide.addClass('active');
    });
  };

  SlideshowView.prototype.update = function($el) {
    this.$el = $el;
    return this._validate();
  };

  return SlideshowView;

})(Backbone.View);

InstagramView = (function(superClass) {
  extend(InstagramView, superClass);

  function InstagramView() {
    return InstagramView.__super__.constructor.apply(this, arguments);
  }

  InstagramView.prototype.initialize = function() {
    this.initializedClass = 'instagram-initialized';
    return this._validate();
  };

  InstagramView.prototype._validate = function() {
    var accessToken, isInitialized;
    this.photoContainer = $('[data-instagram-photos]', this.$el);
    accessToken = $('[data-instagram-token]', this.$el).attr('data-instagram-token');
    isInitialized = this.$el.hasClass(this.initializedClass);
    return this._getPhotos(accessToken, isInitialized);
  };

  InstagramView.prototype._getPhotos = function(accessToken, isInitialized) {
    var url;
    if (!accessToken.length) {
      return this._hasError(false);
    }
    if (isInitialized) {
      return;
    }
    url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + accessToken + "&count=6&callback=";
    return $.ajax({
      type: "GET",
      dataType: "jsonp",
      url: url,
      success: (function(_this) {
        return function(response) {
          var j, len, photo, ref, ref1, ref2;
          if (response.meta.code === 200) {
            ref = response.data;
            for (j = 0, len = ref.length; j < len; j++) {
              photo = ref[j];
              if (photo != null ? (ref1 = photo.images) != null ? (ref2 = ref1.standard_resolution) != null ? ref2.url : void 0 : void 0 : void 0) {
                _this.photoContainer.append("<a\n    class=\"instagram-photo\"\n    target=\"_blank\"\n    href=\"" + photo.link + "\"\n    style=\"background-image: url('" + photo.images.standard_resolution.url + "')\"\n>\n</a>");
              }
            }
            _this.photoContainer.imagesLoaded(function() {
              _this.photoContainer.addClass('visible').height('auto');
              return _this.$('.loading').hide();
            });
            return _this.$el.toggleClass(_this.initializedClass, true);
          } else {
            return _this._hasError(response);
          }
        };
      })(this),
      error: (function(_this) {
        return function(response) {
          return _this._hasError(response);
        };
      })(this)
    });
  };

  InstagramView.prototype._hasError = function(response) {
    this.$el.toggleClass(this.initializedClass, false);
    this.photoContainer.html();
    if (response) {
      return console.log("Instagram error: " + response.meta.error_message);
    }
  };

  InstagramView.prototype.update = function($el) {
    this.$el = $el;
    return this._validate();
  };

  return InstagramView;

})(Backbone.View);

TwitterView = (function(superClass) {
  extend(TwitterView, superClass);

  function TwitterView() {
    return TwitterView.__super__.constructor.apply(this, arguments);
  }

  TwitterView.prototype.initialize = function() {
    this.initializedClass = 'twitter-initialized';
    return this._validate();
  };

  TwitterView.prototype._validate = function() {
    var isInitialized, retweets, username;
    this.tweetContainer = $('[data-twitter-tweets]', this.$el);
    username = $('[data-twitter-username]', this.$el).attr('data-twitter-username');
    retweets = $('[data-show-retweets]', this.$el).data('show-retweets');
    isInitialized = this.$el.hasClass(this.initializedClass);
    if (!isInitialized) {
      return this._fetchTweets(username, retweets);
    }
  };

  TwitterView.prototype._fetchTweets = function(username, retweets) {
    var config;
    config = {
      'profile': {
        'screenName': username
      },
      'maxTweets': 1,
      'enableLinks': true,
      'showUser': true,
      'showTime': true,
      'showRetweet': retweets,
      'customCallback': (function(_this) {
        return function(tweets) {
          return _this.renderTweets(tweets);
        };
      })(this),
      'showInteraction': false
    };
    return twitterFetcher.fetch(config);
  };

  TwitterView.prototype.renderTweets = function(tweets) {
    var j, len, results, tweet;
    if (tweets.length) {
      results = [];
      for (j = 0, len = tweets.length; j < len; j++) {
        tweet = tweets[j];
        tweet = $(tweet);
        this.tweetContainer.append("<div class='tweet-wrap'>" + tweet[1].innerHTML + ("<span class='timestamp'>" + tweet[2].innerHTML + " <span class='divider'>/</span> " + tweet[0].innerHTML + "</span></div>"));
        results.push(this.$el.toggleClass(this.initializedClass, true));
      }
      return results;
    } else {
      this.tweetContainer.html('');
      return console.log("No tweets to display. Most probable cause is an incorrectly entered username.");
    }
  };

  TwitterView.prototype.update = function($el) {
    this.$el = $el;
    return this._validate();
  };

  return TwitterView;

})(Backbone.View);

PasswordView = (function(superClass) {
  extend(PasswordView, superClass);

  function PasswordView() {
    return PasswordView.__super__.constructor.apply(this, arguments);
  }

  PasswordView.prototype.el = $('.password-page-modal-wrapper');

  PasswordView.prototype.events = {
    'click': 'close',
    'click .close-modal': 'close',
    'click .admin-login-modal': 'open'
  };

  PasswordView.prototype.initialize = function() {
    this.sectionBinding();
    this.initializedClass = 'password-initialized';
    return this._validate();
  };

  PasswordView.prototype._validate = function() {
    this.adminLogin = $('.password-page-modal-wrapper');
    this.adminModal = this.adminLogin.find('.password-page-modal');
    this.openByDefault = this.adminLogin.find('[data-open-modal]').length;
    if (this.openByDefault) {
      this.open();
    }
    return WINDOW.resize((function(_this) {
      return function() {
        return _this.formatTheModal();
      };
    })(this));
  };

  PasswordView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-password')) {
          return;
        }
        _this.delegateEvents();
        return _this._validate();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function(event) {
        if (!$(event.target).hasClass('section-password')) {
          return;
        }
        return _this.undelegateEvents();
      };
    })(this));
  };

  PasswordView.prototype.formatTheModal = function() {
    var offset;
    if (WINDOW.height() <= this.adminModal.outerHeight()) {
      return this.adminModal.css({
        'margin-top': 0
      });
    } else {
      offset = (WINDOW.height() - this.adminModal.outerHeight()) / 2;
      return this.adminModal.css({
        'margin-top': offset
      });
    }
  };

  PasswordView.prototype.open = function(e) {
    BODY.css({
      'overflow': 'hidden'
    });
    this.adminLogin.show();
    this.formatTheModal();
    if (!$('html').hasClass('lt-ie9')) {
      this.adminLogin.fadeTo(200, 1);
    }
    return $(document).bind('keyup', (function(_this) {
      return function(e) {
        if (e.keyCode === 27) {
          return _this.close();
        }
      };
    })(this));
  };

  PasswordView.prototype.close = function(e) {
    if ((e == null) || e.target === e.currentTarget) {
      if ($('html').hasClass('lt-ie9')) {
        this.adminLogin.hide();
        BODY.css({
          'overflow': 'auto'
        });
      } else {
        this.adminLogin.fadeTo(200, 0, (function(_this) {
          return function() {
            return _this.adminLogin.hide();
          };
        })(this));
      }
      return $(document).unbind('keyup');
    }
  };

  return PasswordView;

})(Backbone.View);

GiftCardView = (function(superClass) {
  extend(GiftCardView, superClass);

  function GiftCardView() {
    return GiftCardView.__super__.constructor.apply(this, arguments);
  }

  GiftCardView.prototype.initialize = function() {
    return this.addQrCode();
  };

  GiftCardView.prototype.addQrCode = function() {
    var qrWrapper;
    qrWrapper = $('[data-qr-code]');
    return new QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120
    });
  };

  return GiftCardView;

})(Backbone.View);
